const axios = require('axios')

const AJADev = process.env.NODE_ENV === 'development' && process.env.VUE_APP_AGENCY === 'AJA'
    // const AJADev = true

console.log("AJA Development: " + AJADev)

import axiosWrap from '../axiosWrap';
import axiosFormData from '../axiosFormData';

import * as reqBodyMaker from './requestBodyMaker';

import * as mock from '../mock';
// import { resolve } from 'dns';



export const uniqBy = function(array, funOfUniqBy) {
    return Array.from(new Map(array.map(item => [funOfUniqBy(item), item])).values())
}

//取得最新消息
export const getNews = async(userId, div_no, dept_no) => {
    if (AJADev) {
        return mock.news
    }
    // return await axiosWrap('post', `/servletTest/MXH03001`, reqBodyMaker.queryNews(userId, div_no), '最新消息')
    return await axiosWrap('post', `/RestApiAdapter/MXH0_3001/query`, reqBodyMaker.queryNews(userId, div_no, dept_no), null, '最新消息')
}

//取得custs列表
export const getCustomers = async(userId, input, s1, s2, s3, s4, s5, s6, page, order_by, order_asc, rows) => {
    if (AJADev) {
        return mock.customers
    }
    return await axiosWrap('post', `/RestApiAdapter/MXCL_0001/query`, reqBodyMaker.queryCustomers(input, s1, s2, s3, s4, s5, s6, page, order_by, order_asc, rows), null, 'Cust列表')
}

//取得登入者資訊
export const getUser = async(id, pwd) => {
    if (AJADev) {
        return mock.loginUser
    }
    return await axiosWrap('post', `/servletTest/MXL0_0001`, reqBodyMaker.queryUser(id, pwd), null, 'UserLogin')
}

//取得登入者資訊-SSO版本
export const getUserSSO = async() => {
    if (AJADev) {
        return mock.getUserSSO
    }
    return await axiosWrap('post', `/RestApiAdapter/MXL0_0001/query`, reqBodyMaker.queryUserSSO(), null, 'UserLogin SSO版本')
}

//取得該cust詳細資訊 (個人資訊,財務狀況,行銷方式)
export const getCustInfo = async(userId, agnt_id, csid) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '1', ""), null, '取得該cust詳細資訊')
}

// 新增客戶個人頁面點擊log紀錄
export const addCustInfoLog = async(userId, logData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/addCustInfoLog`, reqBodyMaker.addCustInfoLog(userId, logData), null, '新增客戶個人頁面點擊log紀錄')
}

// 查詢客戶個人頁面點擊log紀錄
export const queryCustInfoLog = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/queryCustInfoLog`, reqBodyMaker.queryCustInfoLog(userId), null, '查詢客戶個人頁面點擊log紀錄')
}

//查詢近期搜尋客戶
export const queryRecentCust = async(userId, orderBy, order, act_type) => {
    let text = act_type == 'C' ? '查詢近三個月內成立新契約客戶' : act_type == 'Q' ? '查詢近期搜尋客戶' : '查詢近期新增客戶';
    let url = act_type == 'C' ? '/RestApiAdapter/MXC0_0001/queryNewContractCust' : '/RestApiAdapter/MXC0_0001/queryRecentCust';
    return await axiosWrap('Post', url, reqBodyMaker.queryRecentCust(userId, orderBy, order, act_type), null, text)
}

//取得該cust滿期保單資訊 (滿期目標客戶)
export const getCustFullInfo = async(userId, csid) => {
    if (AJADev) {
        return mock.getCustFullInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3201/queryCrmCsid`, reqBodyMaker.queryCustFullInfo(userId, csid), null, '取得該cust滿期保單資訊')
}

//取得該滿期保單詳細資訊 (滿期目標客戶)
export const getFullPlcInfo = async(userId, plc) => {
    if (AJADev) {
        return mock.getFullPlcInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3201/queryPlc`, reqBodyMaker.getFullPlcInfo(userId, plc), null, '取得該滿期保單資訊')
}

//列印滿期保單聯繫單 (滿期目標客戶)
export const showFullPlcPDF = async(userId, plc, ceempnm) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3201/showPDF`, reqBodyMaker.showFullPlcPDF(userId, plc, ceempnm), null, '取得該滿期保單資訊')
}

//更新該cust滿期保單未拜訪說明 (滿期目標客戶)
export const updateNonVisitReason = async(userId, reportData) => {
    if (AJADev) {
        return mock.updateNonVisitReason
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3201/update`, reqBodyMaker.updateNonVisitReason(userId, reportData), null, '更新該cust滿期保單未拜訪資訊')
}

//更新該cust滿期保單聯繫單最新列印日期 (滿期目標客戶)
export const updatePrintDate = async(userId, plc, csid) => {
    if (AJADev) {
        return mock.updatePrintDate
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3201/updatePrintDate`, reqBodyMaker.updatePrintDate(userId, plc, csid), null, '更新該cust滿期保單聯繫單最新列印日期')
}

//取得該cust詳細資訊 (服務申辦項目)
export const getCustInfo_ServiceCheck = async(userId, agnt_id, csid, curr) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '2', curr), null, '取得該cust詳細資訊_服務申辦項目')
}

//取得保單貸款資料 (服務申辦項目)
export const getCustInfo_PlLoan = async(userId, agnt_id, csid, curr) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '3', curr), null, '取得保單貸款資料_服務申辦項目')
}

//取得易Call保資料 (服務申辦項目)
export const getCustInfo_ECall = async(userId, agnt_id, csid, curr) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '4', curr), null, '取得保單貸款資料_服務申辦項目')
}

//取得客戶名單專區資料
export const getCustInfo_Category = async(userId, agnt_id, csid) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustCategory(userId, agnt_id, csid, '5'), null, '取得客戶名單專區資料')
}

//取得提醒事項
export const getAttention = async(userId, agnt_id, csid) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.getAttention(userId, agnt_id, csid, '6'), null, '取得提醒事項')
}

//取得該cust詳細資訊 (服務申辦項目)
export const getCustInfo_MemberNetwork = async(userId, agnt_id, csid, curr) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '7', curr), null, '取得會員/網路服務資格資料_服務申辦項目')
}

//取得該custFitback健康吧資料
export const getCustFITBACK = async(userId, agnt_id, csid, curr) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '8', curr), null, '取得會員FITBACK資料')
}

//取得該cust人臉申請狀態資料
export const getCustInfo_FaceStatus = async(userId, agnt_id, csid, curr) => {
    if (AJADev) {
        return mock.custInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0001/query`, reqBodyMaker.queryCustInfo(userId, agnt_id, csid, '9', curr), null, '取得會員人臉申請狀態資料')
}

//取得高齡關懷包連結
export const getEldSolicitudeUrl = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXS0_0000/query`, reqBodyMaker.getEldSolicitudeUrl(userId), null, '取得高齡關懷包連結')
}

//新增高齡關懷包Log
export const insertEldSolicitudeLog = async(userId, csid, kind) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_6000/insert`, reqBodyMaker.insertEldSolicitudeLog(userId, csid, kind), null, '新增高齡關懷包Log')
}

//取得拒絕國泰人壽行銷
export const getReject_CathayMarketing = async(userId, csid) => {
    // if(AJADev) {
    //   return mock.custInfo
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0002/query`, reqBodyMaker.queryRejectCathayMarketing(userId, csid), null, '取得拒絕國泰人壽行銷')
}

//取得投資風險屬性
export const getRisk_Attributes = async(csid, nationCode ,birthday) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0002/queryRiskAttributes`, reqBodyMaker.queryRiskAttributes(csid, nationCode, birthday), null, '取得投資風險屬性')
}

// 新增客戶備註
export const insertMemo = async(userId, csid, memo, custType) => {
    // if(AJADev) {
    //   return mock.insertMemo
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_2100/process`, reqBodyMaker.insertMemo(userId, csid, memo, custType), null, '新增客戶備註')
}

// 修改客戶備註
export const modifyMemo = async(userId, csid, memo, custType) => {
    // if(AJADev) {
    //   return mock.modifyMemo
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_2100/process`, reqBodyMaker.modifyMemo(userId, csid, memo, custType), null, '修改客戶備註')
}

//取得該 cust 死亡資訊
export const getCustDie = async(userId, agnt_id, csid) => {
    if (AJADev) {
        return mock.getCustDie
    }
    return await axiosWrap('Post', `/RestApiAdapter/ADD_CUST_API/querydie`, reqBodyMaker.getCustDie(userId, agnt_id, csid), null, '取得該 cust 死亡資訊')
}

//取得好康分享
export const getShareVideo = async(userId) => {
    if (AJADev) {
        return mock.shareVideo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_5001/query`, reqBodyMaker.queryVideos(userId), null, '好康分享')
}

//取得首頁的近期動態
export const getRecentDynamic = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_6001/query`, reqBodyMaker.getRecentDynamic(userId), null, '取得首頁的近期動態')
}

//取得戶長列表
export const getFamilys = async(userId) => {
    // if(AJADev) {
    //   return mock.getFamilys
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F02`, reqBodyMaker.getFamilys(userId), null, '取得戶長列表')
}

//取得該cust的家戶成員
export const getFamilyMembers = async(userId, csid, serNo = null) => {
    if (AJADev) {
        return mock.familyMember
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F01`, reqBodyMaker.queryFamilyMem(userId, csid, serNo), null, '家戶成員byCsid')
}

//取得可加入家戶之成員
export const getFamilInsertList = async(userId) => {
    if (AJADev) {
        return mock.getFamilInsertList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F02`, reqBodyMaker.getFamilInsertList(userId), null, '取得可加入家戶之成員')
}

// 新增家戶之成員
export const addFamilyMembers = async(userId, insertData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F03`, reqBodyMaker.addFamilyMembers(userId, insertData), null, '新增家戶之成員')
}

// 新增新客戶至保校家庭
export const addNewCustFamilyMembers = async(userId, insertData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXAC_0002/process`, reqBodyMaker.addFamilyMembers(userId, insertData), null, '新增新客戶至保校家庭')
}

// 刪除家戶之成員
export const deleteFamilyMembers = async(userId, insertData) => {
    // if(AJADev) {
    //   return mock.getFamilInsertList
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F03`, reqBodyMaker.deleteFamilyMembers(userId, insertData), null, '刪除家戶之成員')
}

// 修改家戶之成員
export const updateFamilyMembers = async(userId, insertData) => {
    // if(AJADev) {
    //   return mock.getFamilInsertList
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F03`, reqBodyMaker.updateFamilyMembers(userId, insertData), null, '刪除家戶之成員')
}

// 儲存家戶之成員
export const submitFamilyMembers = async(userId, custid, insertData) => {
    // if(AJADev) {
    //   return mock.submitFamilyMembers
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/submit`, reqBodyMaker.submitFamilyMembers(userId, custid, insertData), null, '儲存家戶之成員')
}

//取得該cust的所有群組
export const getGroupOfCust = async(userId, csid) => {
    if (AJADev) {
        return mock.group
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/C01`, reqBodyMaker.queryGroup(userId, null, csid, null, null, 'C01', 0), null, '全部群組byCsid')
}

//用grp_id取得群組成員
export const getGroupMember = async(userId, grpid) => {
    if (AJADev) {
        return mock.getGroupMember
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/G11`, reqBodyMaker.queryGroup(userId, grpid, null, null, null, 'G11', 0), null, '群組成員byGrpId').then(result => {
        if (result.body.groups) {
            let checkedDatas = result.body.groups.filter(item => item.ID)
            let returnAry = uniqBy(checkedDatas, (item) => { return item.ID })
            returnAry.forEach(item => {
                // 先判斷是否有電話區號及號碼
                if (item.HOME_TEL_AREA && item.HOME_TEL) {
                    item.PHONE = item.HOME_TEL_AREA + '-' + item.HOME_TEL
                } else {
                    item.PHONE = '— —'
                }
            })
            return returnAry
        } else {
            return []
        }
    })
}

//取得此Agnt的所有群組
export const getGroupOfAgnt = async(userId, agnt_id, filterCondition) => {
    if (AJADev) {
        return mock.group
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/G01`, reqBodyMaker.queryGroup(userId, null, null, agnt_id, null, 'G01', filterCondition), null, '全部群組byAgntId')
}

//用grp_name搜尋此Agnt所擁有的群組
export const getGroupOfAgntByName = async(userId, agnt_id, keyword, filterCondition) => {
    return await axiosWrap('Post', keyword.trim().length ? `/RestApiAdapter/MXG0_0000/C16` : `/RestApiAdapter/MXG0_0000/G01`, reqBodyMaker.queryGroup(userId, null, null, agnt_id, keyword, keyword.trim().length ? 'C16' : 'G01', filterCondition), null, '搜尋群組byName')
}

//更新群組(group & groupMem 都更新)
export const updateGroup = async(agnt_id, grp_id, grp_name, members) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/G00`, reqBodyMaker.updateGroup(agnt_id, grp_id, grp_name, members, 'G00'), null, '更新群組-grp&grpMem')
}

//更新群組(groupMem 更新)
export const updateGrpMem = async(agnt_id, grp_id, grp_name, members) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/G12`, reqBodyMaker.updateGrpMem(agnt_id, grp_id, grp_name, members, 'G12'), null, '更新群組-grpMem')
}

//刪除群組(group & groupMem 都刪除)
export const removeGrp = async(userId, agnt_id, grp_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/G14`, reqBodyMaker.removeGrp(userId, agnt_id, grp_id, 'G14'), null, '刪除群組')
}

//更新Cust所屬群組
export const updateGroupsByCust = async(userId, agnt_id, csid, groups) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/C14`, reqBodyMaker.updateGroupsByCust(userId, agnt_id, csid, groups), null, '更新Cust所屬群組')
}

//更新Cust所屬群組
export const createGroupsByCust = async(userId, agnt_id, csid, source, groups) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/C15`, reqBodyMaker.createGroupsByCust(userId, agnt_id, csid, source, groups), null, '將客戶加入新群組內')
}

//查詢國泰壽險
export const getCustInsurance = async(userId, custId) => {
    if (AJADev) {
        return mock.cathayInsurance
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0000/query`, reqBodyMaker.queryCustInsurance(userId, custId), null, '國泰壽險')
}

//查詢其他效力保單
export const getInvalidPolicyInfo = async(userId, custId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0000/queryInvalidPolicyInfo`, reqBodyMaker.queryCustInsurance(userId, custId), null, '國泰壽險-其他效力保單')
}

//查詢保單明細-保全訊息-給付紀錄
export const getInsuDetailPayRecords = async(userId, policyNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_5003/query`, reqBodyMaker.queryInsuPayRecords(userId, policyNo), null, '給付紀錄')
}


//查詢是否為產險客戶(包含客戶Info資料)
export const isPropertyCustomer = async(userId, custId, isFromPropertyCust = false) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXPR_0001/query`, reqBodyMaker.isPropertyCustomer(userId, custId, isFromPropertyCust), null, '查詢是否為產險客戶(包含客戶Info資料)')
}

//查詢國泰產險-團險
export const getCustInsuranceGroup = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayGroup
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0003/query`, reqBodyMaker.queryCustInsuranceGroupAndAccident(userId, csid, null), null, '國泰團險')
}

//查詢國泰產險-意外險
export const getCustInsuranceAccident = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayAccident
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0004/query`, reqBodyMaker.queryCustInsuranceGroupAndAccident(userId, csid, null), null, '國泰意外險')
}

//查詢國泰產險-健康險
export const getCustInsurance_CCIPLN4 = async(userId, csid, isFromPropertyCustomer = false) => {
    if (AJADev) {
        return mock.cathayHealth
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0005/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true, isFromPropertyCustomer), null, '國泰產險-健康險')
}

//查詢國泰產險-傷害險
export const getCustInsurance_CCIPLN2 = async(userId, csid, isFromPropertyCustomer = false) => {
    if (AJADev) {
        return mock.cathayHarm
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0006/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true, isFromPropertyCustomer), null, '國泰產險-傷害險')
}

//查詢國泰產險-新種險
export const getCustInsurance_CCIPLN1 = async(userId, csid, isFromPropertyCustomer = false) => {
    if (AJADev) {
        return mock.cathayNewInsure
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0007/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true, isFromPropertyCustomer), null, '國泰產險-新種險')
}

//查詢國泰產險-旅綜險
export const getCustInsurance_CCIPLN3 = async(userId, csid, isFromPropertyCustomer = false) => {
    if (AJADev) {
        return mock.cathayTravel
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0009/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true, isFromPropertyCustomer), null, '國泰產險-旅綜險')
}

//查詢國泰產險-旅綜險-被保人名冊
export const getCustInsurance_CCIPLN3_detail = async(userId, csid, policy_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0009/queryDetail`, reqBodyMaker.getCustInsurance_CCIPLN3_detail(userId, csid, policy_no), null, '查詢國泰產險-旅綜險-被保人名冊')
}

//查詢國泰產險-車險
export const getCustInsurance_CCIPLC1 = async(userId, csid, isFromPropertyCustomer = false) => {
    if (AJADev) {
        return mock.cathayCar
    }
    // return await axiosWrap('Post', `/dao/CCIPLCI`, reqBodyMaker.queryCustPropertyInsurance(userId, csid), null, '國泰產險-車險')
    // return await axiosWrap('Post', `/servletTest/CCIPLCI`, reqBodyMaker.queryCustPropertyInsurance(userId, csid), null, '國泰產險-車險')
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0010/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true, isFromPropertyCustomer), null, '國泰產險-車險')
}

//查詢國泰產險-火險
export const getCustInsurance_CCIPLF1 = async(userId, csid, isFromPropertyCustomer = false) => {
    if (AJADev) {
        return mock.cathayFire
    }
    // return await axiosWrap('Post', `/dao/CCIPLFI`, reqBodyMaker.queryCustPropertyInsurance(userId, csid), null, '國泰產險-火險')
    // return await axiosWrap('Post', `/servletTest/CCIPLFI`, reqBodyMaker.queryCustPropertyInsurance(userId, csid), null, '國泰產險-火險')
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0011/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true, isFromPropertyCustomer), null, '國泰產險-火險')
}

//查詢國泰產險-車險明細
export const queryCarsDetail = async(userId, ceplcno, isFromPropertyCustomer = false) => {
    // if(AJADev) {
    //   return mock.queryCarsDetail
    // }
    return await axiosWrap('Post', `/RestApiAdapter/CCIPLC2_API/query`, reqBodyMaker.queryCarsDetail(userId, ceplcno, isFromPropertyCustomer), null, '國泰產險-車險明細')
}

//查詢國泰產險-火險明細
export const queryFireDetail = async(userId, ceplcno, isFromPropertyCustomer = false) => {
    // if(AJADev) {
    //   return mock.queryFireDetail
    // }
    return await axiosWrap('Post', `/RestApiAdapter/CCIPLF2_API/query`, reqBodyMaker.queryFireDetail(userId, ceplcno, isFromPropertyCustomer), null, '國泰產險-火險明細')
}

//查詢國泰產險-新種險明細
export const queryNewIsureDetail = async(userId, ceplcno, isFromPropertyCustomer = false) => {
    return await axiosWrap('Post', `/RestApiAdapter/CCIPLN1_API/queryDetail`, reqBodyMaker.queryFireDetail(userId, ceplcno, isFromPropertyCustomer), null, '國泰產險-新種險明細')
}

//查詢同業壽險
export const getCustOtherInsurance = async(userId, csid) => {
    if (AJADev) {
        return mock.getCustOtherInsurance
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0002/query`, reqBodyMaker.queryCustOtherInsurance(userId, csid), null, '同業壽險')
}

//查詢同業產險-新種險
export const getCustOtherPropertyInsurance_NewIns = async(userId, csid) => {
    if (AJADev) {
        return mock.otherNewInsure
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0008/query`, reqBodyMaker.queryCustOtherPropertyInsurance(userId, csid, '3'), null, '同業產險-新種險')
}

//查詢同業產險-車險
export const getCustOtherPropertyInsurance_CarIns = async(userId, csid) => {
    if (AJADev) {
        return mock.otherCar
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0008/query`, reqBodyMaker.queryCustOtherPropertyInsurance(userId, csid, '1'), null, '同業產險-車險')
}

//查詢同業產險-火險
export const getCustOtherPropertyInsurance_FireIns = async(userId, csid) => {
    if (AJADev) {
        return mock.otherFire
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0008/query`, reqBodyMaker.queryCustOtherPropertyInsurance(userId, csid, '2'), null, '同業產險-火險')
}

//查詢保單無記名家庭關係
export const queryFamilyRelationOfInsurance = async(userId, custId) => {
    if (AJADev) {
        return mock.familyMember
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1520/query`, reqBodyMaker.queryFamilyRelationOfInsurance(userId, custId), null, '查詢保單無記名家庭關係')
}

//新增保單無記名家庭關係
export const addFamilyRelationOfInsurance = async(userId, custId, cop_id, name, birthday, kind) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1520/query`, reqBodyMaker.addFamilyRelationOfInsurance(userId, custId, cop_id, name, birthday, kind), null, '新增保單無記名家庭關係')
}

//更新保單無記名家庭關係
export const updateFamilyRelationOfInsurance = async(userId, custId, cop_id, name, birthday, kind) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1520/query`, reqBodyMaker.updateFamilyRelationOfInsurance(userId, custId, cop_id, name, birthday, kind), null, '更新保單無記名家庭關係')
}

//刪除保單無記名家庭關係
export const deleteFamilyRelationOfInsurance = async(userId, custId, cop_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1520/query`, reqBodyMaker.deleteFamilyRelationOfInsurance(userId, custId, cop_id), null, '刪除保單無記名家庭關係')
}

//查詢紀錄簿
export const queryNoteList = async(userId, custId, is_done, rocyear) => {
    if (AJADev) {
        return mock.queryNoteList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_1020/query`, reqBodyMaker.getQueryNoteList(userId, custId, is_done, rocyear), null, '查詢紀錄簿')
}


//查詢BOX紀錄
export const queryBoxRecord = async(userId, agId, custId, is_done, rocyear) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_1020/query`, reqBodyMaker.queryBoxRecord(userId, agId, custId, is_done, rocyear), null, '查詢BOX紀錄')
}

//增值回饋分享金_保單主約資料查詢
export const valueAdded_queryPolicyInfo = async(userId, policy_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1530/query`, reqBodyMaker.valueAdded_queryPolicyInfo(userId, policy_no), null, '增值回饋分享金_保單主約資料查詢')
}

// 取得繳清保額繳清始期等相關資訊(CRM使用)
export const queryPaupInfo = async(userId, policy_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1530/queryPaupInfo`, reqBodyMaker.queryPaupInfo(userId, policy_no), null, '取得繳清保額繳清始期等相關資訊(CRM使用)')
}

//服務歷程
export const getServiceRecord = async(userId, csid) => {
    if (AJADev) {
        return mock.service
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC5_5000/query`, reqBodyMaker.getServiceRecordBody(userId, csid), null, '服務歷程')
}

//查詢筆記
export const getNote = async(userId, csid) => {
    return await axiosWrap('Post', `/servletTest/MXC3_1020`, reqBodyMaker.personalNote('query', userId, csid), null, '查詢筆記')
}

//新增筆記
export const addNote = async(userId, csid, noteContent) => {
    return await axiosWrap('Post', `/servletTest/MXC3_1020`, reqBodyMaker.personalNote('insert', userId, csid, noteContent), null, '新增筆記')
}

//修改筆記
export const updateNote = async(userId, csid, noteContent, uDate, uTime) => {
    return await axiosWrap('Post', `/servletTest/MXC3_1020`, reqBodyMaker.personalNote('update', userId, csid, noteContent, uDate, uTime), null, '修改筆記')
}

//取得客戶IAA
export const getCustIAA = async(userId, csid, api_id) => {
    if (AJADev) {
        return mock.getCustIAA
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_3001/process`, reqBodyMaker.getCustIAA(userId, csid, api_id), null, '取得客戶IAA')
}

//查詢回報IAA
export const queryIAA = async(userId, csid, api_id) => {
    if (AJADev) {
        return mock.queryIAA
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_3001/process`, reqBodyMaker.ReportIAA_Request(userId, csid, null, {}, api_id), null, '查詢回報IAA')
}

//查詢IAA客戶資料[API]
export const queryIAACust = async(userId, csid, api_id) => {
    if (AJADev) {
        return mock.queryIAACust
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_3001/process`, reqBodyMaker.ReportIAA_Request(userId, csid, null, {}, api_id), null, '查詢IAA客戶資料[API]')
}

//新增回報IAA
export const addIAA_API = async(userId, csid, check, check_item, api_id) => {
    if (AJADev) {
        return mock.addIAA_API
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_3001/process`, reqBodyMaker.ReportIAA_Request(userId, csid, check, check_item, api_id), null, '新增回報IAA')
}

//更新回報IAA
export const updateIAA_API = async(userId, csid, check, check_item, api_id) => {
    if (AJADev) {
        return mock.updateIAA_API
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_3001/process`, reqBodyMaker.ReportIAA_Request(userId, csid, check, check_item, api_id), null, '更新回報IAA')
}

//查詢房貸資訊
export const queryHousingLoans = async(userId, csid) => {
    if (AJADev) {
        return mock.queryHousingLoans
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC7_0001/query`, reqBodyMaker.housingLoans(userId, csid), null, '查詢房貸資訊')
}

//列印郵政局pdf
export const getPostalPDF = async(userId, csidAry, isAll, keyword, s1, s2, s3, s4, s5, s6, order_by, order_asc, page, rows, type) => {
    if (AJADev) {
        return await new Promise((resol, reject) => {
            axios({
                    methods: "POST",
                    url: '/assets/test.pdf',
                    data: reqBodyMaker.printPDF(userId, csidAry, 'postPDF'),
                    responseType: 'arraybuffer'
                }).then(response => {
                    // console.log(`Got[${debugMsg}]Res:${apiUrl}`)
                    console.log(response)
                    if (response.status === 200) {
                        resol(response.data);
                    } else {
                        console.error(response);
                        reject(response.status);
                    }
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                })
        })
    } else {
        let newArr = [];
        for (let i = 0; i < csidAry.length; i++) {
            newArr.push(csidAry[i]);
        }

        // console.log(newArr);

        return await axiosWrap('Post', `/RestApiAdapter/MXCL_2002/postPDF`, reqBodyMaker.printPDF(userId, csidAry, 'postPDF', isAll, keyword, s1, s2, s3, s4, s5, s6, order_by, order_asc, page, rows, type), 'arraybuffer', '列印郵政局pdf')
    }
}

//列印電話簿pdf
export const getPhonePDF = async(userId, csidAry, isAll, keyword, s1, s2, s3, s4, s5, s6, order_by, order_asc, page, rows) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_2002/phonePDF`, reqBodyMaker.printPDF(userId, csidAry, 'phonePDF', isAll, keyword, s1, s2, s3, s4, s5, s6, order_by, order_asc, page, rows), 'arraybuffer', '列印電話簿pdf')
}

//列印投資績效pdf
export const getInvestPDF = async(userId, reqObj) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_2002/investPDF`, reqBodyMaker.printInvPDF(userId, reqObj), 'arraybuffer', '列印投資績效pdf')
}

//紀錄列印預設地址
export const savePrintAddress = async(userId, selectAddress, selectCompanyAddress, isAddress, isCompanyAddress) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_2003/savePrintAddress`, reqBodyMaker.savePrintAddress(userId, selectAddress, selectCompanyAddress, isAddress, isCompanyAddress), null, '紀錄列印預設地址')
}

//查詢客戶資料_儲存預設列印地址頁面用
export const getCustDataForSavePrint = async(userId, custids) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_2003/query`, reqBodyMaker.getCustDataForSavePrint(userId, custids), null, '查詢客戶資料_儲存列印預設地址頁面用')
}

//查詢分區與郵遞區號byCity
export const queryDistByCity = async(userId, city) => {
    if (AJADev) {
        return mock.queryDistByCity
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXAC_0001/process`, reqBodyMaker.queryDistByCity(userId, city), null, '查詢分區與郵遞區號')
}

//查詢職業類別
export const getJobs = async(userId) => {
    if (AJADev) {
        return mock.getJobs
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_8000/query`, reqBodyMaker.getJobs(userId), null, '查詢職業類別')
}

//依職業中文模糊搜尋取得職業代碼資料模組
export const getJobsByJobName = async(userId, jobName) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_8000/queryByJobName`, reqBodyMaker.getJobsByJobName(userId, jobName), null, '依職業中文模糊搜尋取得職業代碼資料')
}

//新增Cust
export const addNewCust = async(userId, data, trn_cd) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXAC_0001/process`, reqBodyMaker.insertNewCust(userId, data, trn_cd), null, '新增Cust')
}

//新增Cust地址經緯度
export const AddLatAndLnt = async(userId, csId, address, type) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_7000/insert`, reqBodyMaker.AddLatAndLnt(userId, csId, address, type), null, '新增Cust地址經緯度')
}

//刪除客戶
export const deleteCust = async(userId, custId, time, cust_name, csidAry, keyword) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_6030/delete`, reqBodyMaker.deleteCust(userId, custId, time, cust_name, csidAry, keyword), null, '刪除客戶')
}

//編輯客戶資料更新時間_多筆
export const retainCustomers = async(userId, selection, arg) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0020/processUpdatetime`, reqBodyMaker.retainCustomers(userId, selection, arg), null, '編輯客戶資料更新時間_多筆')
}

// 業務員確認客戶同意蒐集資料寄送email
export const sendDataCollectionEmail = async(userId, data, mailAttachmentName) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0030/send`, reqBodyMaker.sendDataCollectionEmail(userId, data, mailAttachmentName), null, '業務員確認客戶同意蒐集資料寄送email')
}

// 增值回饋分享金試算表資料寄送email
export const sendValueAddedBonusIllustrationEmail = async(userId, data, mailAttachmentName) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1530/send`, reqBodyMaker.sendValueAddedBonusIllustrationEmail(userId, data ,mailAttachmentName), null, '增值回饋分享金試算表資料寄送email')
}

//申辦進度-新契約 
export const queryProgressNewConTract = async(userId, custId) => {
    if (AJADev) {
        return mock.progress1
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC6_1000/query`, reqBodyMaker.queryProgressNewConTract(userId, custId), null, '申辦進度-新契約')
}

//申辦進度-放款
export const queryProgressLoan = async(userId, custId) => {
    if (AJADev) {
        return []
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC6_1004/query`, reqBodyMaker.queryProgressLoan(userId, custId), null, '申辦進度-放款')
}

//申辦進度-保全
export const queryPayRecord = async(userId, custId) => {
    if (AJADev) {
        return mock.queryPayRecord
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC6_3000/query`, reqBodyMaker.queryPayRecord(userId, custId), null, '申辦進度-保全')
}

//申辦進度-理賠
export const queryInsuranceClaimRecord = async(userId, custId) => {
    if (AJADev) {
        return []
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC6_2000/query`, reqBodyMaker.queryInsuranceClaimRecord(userId, custId), null, '申辦進度-理賠')
}

//申辦進度-保費
export const queryPremiumRecord = async(userId, custId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC6_6000/query`, reqBodyMaker.queryPremiumRecord(userId, custId), null, '申辦進度-保費')
}

//申辦進度-整合行銷
export const queryIntegratedMarketing = async(userId, custId) => {
    if (AJADev) {
        return []
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC6_4001/query`, reqBodyMaker.queryIntegratedMarketing(userId, custId), null, '申辦進度-整合行銷')
}

//查詢主約基本資料
export const queryMainPolicyInfo = async(policy_no, qry_id) => {
    if (AJADev) {
        return mock.queryMainPolicyInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_5000/query`, reqBodyMaker.queryMainPolicyInfo(policy_no, qry_id), null, '查詢主約基本資料')
}

//查詢附約明細
export const queryMinorInsurDetail = async(userId, policyNo) => {
    if (AJADev) {
        return mock.queryMinorInsurDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_5001/query`, reqBodyMaker.minorInsurDetail(userId, policyNo), null, '附約明細')
}

//查詢主約受益人明細
export const queryMainPolicyBeneficiariesInfo = async(userId, policy_no) => {
    if (AJADev) {
        return mock.queryMainPolicyBeneficiariesInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_5007/query`, reqBodyMaker.queryMainPolicyBeneficiariesInfo(userId, policy_no), null, '查詢主約受益人明細')
}

//查詢投資績效
export const queryInvestPerformance = async(userId, policy_no) => {
    // if (AJADev) {
    //   return mock.queryInvestPerformance
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1604/query`, reqBodyMaker.queryInvestPerformance(userId, policy_no), null, '查詢投資績效')
}

//查詢投資約定
export const queryInvestProfit = async(userId, custId, policy_no) => {
    if (AJADev) {
        return mock.queryInvestProfit
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1605/query`, reqBodyMaker.queryInvestProfit(userId, custId, policy_no), null, '查詢投資約定')
}

//查詢繳費訊息
export const queryPaymentMessage = async(userId, policy_no) => {
    if (AJADev) {
        return mock.queryPaymentMessage
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1502/query`, reqBodyMaker.queryPaymentMessage(userId, policy_no), null, '查詢繳費訊息')
}

//查詢各功能的企劃單位連絡方式
export const getContactInfo = async(userId, function_name) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_5100/query`, reqBodyMaker.getContactInfo(function_name), null, '查詢各功能的企劃單位連絡方式')
}

//以流水編號查詢各功能的企劃單位連絡方式
export const getContactInfoBySerNo = async(userId, ser_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/DTMXS001_API/query3`, reqBodyMaker.getContactInfoBySerNo(userId, ser_no), null, '以流水編號查詢各功能的企劃單位連絡方式')
}

//親疏等級-查詢問券是否已完成
export const getSurveyInfo = async(userId, custId, surveyNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_4001/query`, reqBodyMaker.getSurveyInfo(userId, custId, surveyNo), null, '親疏等級-查詢問券是否已完成')
}

//編輯客戶財務狀況
export const editCustFinancial = async(userId, csid, data, custType) => {
    if (AJADev) {
        return mock.editCustFinancial
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_5020/put`, reqBodyMaker.editCustFinancial(userId, csid, data, custType), null, '編輯客戶財務狀況')
}

//編輯客戶個人資訊&基本資料
export const editCustInfo = async(userId, csid, headerData, bodyData) => {
    if (AJADev) {
        return mock.editCustInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0020/put`, reqBodyMaker.editCustInfo(userId, csid, headerData, bodyData), null, '編輯客戶個人資訊&基本資料')
}


//新增業務員確認客戶同意蒐集資料LOG
export const insertDataCollectionLog = async(userId, csid, trn_cd) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0020/insert`, reqBodyMaker.insertDataCollectionLog(userId, csid, trn_cd), null, '新增業務員確認客戶同意蒐集資料LOG')
}

//新增業務員點擊LOG
export const addActionLog = async(userId, action_item, csid) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0003/insert`, reqBodyMaker.addActionLog(userId, action_item, csid), null, '新增業務員點擊LOG')
}

//查詢所有主附約商品名稱&ID
export const queryPlanCode = async(userId, type) => {
    if (AJADev) {
        return mock.queryPlanCode
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXF1_1000/query`, reqBodyMaker.queryPlanCode(userId, type), null, '查詢所有主附約商品名稱&ID')
}

//取得所有條件篩選項目
export const getSearchFilter = async(userId) => {
    if (AJADev) {
        return mock.getSearchFilter
    }
    return await axiosWrap('Post', `/RestApiAdapter/INITALPAGECONDITION_API/query`, reqBodyMaker.getSearchFilter(userId), null, '取得所有條件篩選項目')
}

//取得自訂篩選條件
export const getCustomizeFilter = async(userId) => {
    if (AJADev) {
        return { body: '', header: '' }
    }
    return await axiosWrap('Post', `/RestApiAdapter/SELECTOWNCONDITION_API/query`, reqBodyMaker.getCustomizeFilter(userId), null, '取得自訂篩選條件')
}

//編輯自訂篩選條件
export const modifyCustomizeFilter = async(userId, filterItem) => {
    if (AJADev) {
        return mock.modifyCustomizeFilter
    }
    return await axiosWrap('Post', `/RestApiAdapter/MODIFYOWNCONDITION_API/put`, reqBodyMaker.modifyCustomizeFilter(userId, filterItem), null, '編輯自訂篩選條件')
}

//查詢客戶by條件篩選
export const queryCustListByCustomized = async(userId, conditionsObj, option_ch) => {
    if (AJADev) {
        return mock.queryCustListByCustomized
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXF0_0000/query`, reqBodyMaker.queryCustListByCustomized(userId, conditionsObj, option_ch), null, '查詢客戶by條件篩選')
}

//查詢產險續保保單清單
export const queryPropertyInsurance = async(userId, conditionsObj, option_ch) => {
    if (AJADev) {
        return mock.queryPropertyInsurance
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXPR_F000/query`, reqBodyMaker.queryPropertyInsurance(userId, conditionsObj, option_ch), null, '產險續保保單清單')
}

//查詢主管推薦by條件篩選
export const queryDevCondition = async(userId, divNo) => {
    // if(AJADev) {
    //   return mock.queryDevCondition
    // }
    return await axiosWrap('Post', `/RestApiAdapter/DEVCONDITION_API/query`, reqBodyMaker.queryDevCondition(userId, divNo), null, '查詢主管推薦by條件篩選')
}

//單位條件的Log_主管推薦
export const queryDevConditionLog = async(userId, serNo, divNo, depNo) => {
    // if(AJADev) {
    //   return mock.queryDevConditionLog
    // }
    return await axiosWrap('Post', `/RestApiAdapter/INSERTDEVCONDITIONLOG_API/process`, reqBodyMaker.queryDevConditionLog(userId, serNo, divNo, depNo), null, '單位條件的Log_主管推薦')
}

//查詢客戶>>取得查詢紀錄
export const getSearchRecord = async(userId) => {
    if (AJADev) {
        return mock.getSearchRecord
    }
    return await axiosWrap('Post', `/RestApiAdapter/SEARCHRECORD_API/query`, reqBodyMaker.getSearchRecord(userId), null, '查詢客戶>>取得查詢紀錄')
}

//查詢客戶>>取得我的最愛
export const getSearchFavorite = async(userId) => {
    if (AJADev) {
        return mock.getSearchFavorite
    }
    return await axiosWrap('Post', `/RestApiAdapter/SEARCHRECORD_API/query`, reqBodyMaker.getSearchFavorite(userId), null, '查詢客戶>>取得我的最愛')
}

//查詢客戶>>新增我的最愛
export const insertFavorite = async(userId, insertData) => {
    return await axiosWrap('Post', `/RestApiAdapter/INSERTFAVORITECONDITION_API/post`, reqBodyMaker.insertFavorite(userId, insertData), null, '查詢客戶>>新增我的最愛')
}

//查詢客戶>>編輯我的最愛
export const modifyFavorite = async(userId, modifyData) => {
    if (AJADev) {
        return mock.modifyFavorite
    }
    return await axiosWrap('Post', `/RestApiAdapter/MODIFYFAVORITECONDITION_API/put`, reqBodyMaker.modifyFavorite(userId, modifyData), null, '查詢客戶>>編輯我的最愛')
}

//查詢客戶>>刪除我的最愛
export const deleteFavorite = async(userId, deleteName) => {
    if (AJADev) {
        return mock.deleteFavorite
    }
    return await axiosWrap('Post', `/RestApiAdapter/DELETEFAVORITECONDITION_API/delete`, reqBodyMaker.deleteFavorite(userId, deleteName), null, '查詢客戶>>刪除我的最愛')
}

//點選訊息
export const selectMessage = async(userId) => {
    if (AJADev) {
        return mock.selectMessage
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_1001/query`, reqBodyMaker.selectMessage(userId), null, '點選訊息')
}

//點選訊息-查詢個人資訊
export const selectMsgCustInfo = async(userId, id) => {
    // if(AJADev) {
    //   return mock.getSearchFavorite
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_1002/queryCust`, reqBodyMaker.selectMsgCustInfo(userId, id), null, '點選訊息-查詢個人資訊')
}

//查詢新契約變更項目
export const queryh013 = async(userId, id) => {
    // if(AJADev) {
    //   return mock.getSearchFavorite
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_1001/queryid`, reqBodyMaker.queryh013(userId, id), null, '查詢新契約變更項目')
}

//點選訊息-更新
export const updCustMsgCust = async(userId, updInfo, csid) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_1002/process`, reqBodyMaker.updCustMsgCust(userId, updInfo, csid), null, '點選訊息-更新')
}

//判斷是否為投資型商品或IUL商品
export const isInvProd = async(userId, prodId) => {
    if (AJADev) {
        return mock.isInvProd
    }
    return await axiosWrap('Post', `/RestApiAdapter/JUDGE_INV_PROD_API/query`, reqBodyMaker.isInvProd(userId, prodId), null, '判斷是否為投資型商品或IUL商品')
}

// 以保單號碼查詢服務件
export const checkInsByNo = async(userId, cedvno3, plcno) => {
    if (AJADev) {
        return mock.checkInsByNo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1003/query`, reqBodyMaker.checkInsByNo(userId, cedvno3, plcno), null, '以保單號碼查詢服務件')
}

// 以ID查詢服務件
export const checkInsById = async(userId, cedvno3, ceapcno) => {
    if (AJADev) {
        return mock.checkInsById
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1003/query`, reqBodyMaker.checkInsById(userId, cedvno3, ceapcno), null, '以ID查詢服務件')
}

// 查詢撥出各類別業務員數與已撥客戶
export const getOutSegment = async(userId, cedvno3, role_id) => {
    if (AJADev) {
        return mock.getOutSegment
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1004/query`, reqBodyMaker.getOutSegment(userId, cedvno3, role_id), null, '查詢撥出各類別業務員數與已撥客戶')
}

// 查詢撥入各類別業務員數與已撥客戶
export const getInSegment = async(userId, cedvno3, role_id) => {
    if (AJADev) {
        return mock.getInSegment
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1004/query`, reqBodyMaker.getInSegment(userId, cedvno3, role_id), null, '查詢撥入各類別業務員數與已撥客戶')
}

// 查詢轄下撥出人員
export const getOutAgnClcNo = async(userId, cedvno3) => {
    if (AJADev) {
        return mock.getOutAgnClcNo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1001/query`, reqBodyMaker.getOutAgnClcNo(userId, cedvno3), null, '查詢轄下撥出人員')
}

// 查詢轄下撥入人員
export const getInAgnClcNo = async(userId, cedvno3) => {
    if (AJADev) {
        return mock.getInAgnClcNo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1001/query`, reqBodyMaker.getInAgnClcNo(userId, cedvno3), null, '查詢轄下撥入人員')
}


// 查詢各類別人員明細
export const getSegmentAgnt = async(userId, cedvno3, segment) => {
    if (AJADev) {
        return mock.getSegmentAgnt
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1002/query`, reqBodyMaker.getSegmentAgnt(userId, cedvno3, segment), null, '查詢各類別人員明細')
}

// 查詢區部未訪件單位統計層資料
export const getSegmentUnitsData = async(userId, cedvno3, segmentCode, segmentName) => {
    if (AJADev) {
        return mock.getSegmentAgnt
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1012/query`, reqBodyMaker.getSegmentUnitsData(userId, cedvno3, segmentCode, segmentName), null, '查詢區部未訪件單位統計層資料')
}


// 查詢智能配對資料
export const querySmartMappingData = async(userId, reqData) => {
    // if (AJADev) {
    //     return mock.querySmartMappingData
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1011/query`, reqBodyMaker.querySmartMappingData(userId, reqData), null, '查詢智能配對資料')
}

// 取得同業壽險公司別
export const getInsuranceCompanyList = async(userId) => {
    if (AJADev) {
        return mock.getInsuranceCompanyList
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_INSURANCE_COMPANY_LIST_API/query`, reqBodyMaker.getInsuranceCompanyList(userId), null, '取得同業壽險公司別')
}

//取得同業壽險主約險種
export const getInsuraneProduct = async(userId, companyId) => {
    if (AJADev) {
        return mock.getInsuraneProduct
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_INSURANCE_PRODUCT_API/query`, reqBodyMaker.getInsuraneProduct(userId, companyId), null, '取得同業壽險主約險種')
}

//取得同業壽險附約險種
export const getAdditionalInsuranceProduct = async(userId, companyId) => {
    if (AJADev) {
        return mock.getAdditionalInsuranceProduct
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_ADDITIONAL_INSURANCE_PRODUCT_API/query`, reqBodyMaker.getAdditionalInsuranceProduct(userId, companyId), null, '取得同業壽險附約險種')
}

// 取得同業壽險主約商品的個別資訊
export const getProductDetail = async(userId, productId) => {
    if (AJADev) {
        return mock.getProductDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_PRODUCT_DETAIL_API/query`, reqBodyMaker.getProductDetail(userId, productId), null, '取得同業壽險主約商品的個別資訊')
}

//取得同業壽險附約商品的個別資訊
export const getAdditionalProductDetail = async(userId, productId) => {
    if (AJADev) {
        return mock.getAdditionalProductDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_ADDITIONAL_PRODUCT_DETAIL_API/query`, reqBodyMaker.getAdditionalProductDetail(userId, productId), null, '取得同業壽險附約商品的個別資訊')
}

// 新增同業壽險主約
export const addOtherPrimaryContract = async(userId, form) => {
    if (AJADev) {
        return mock.addOtherPrimaryContract
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_2010/post`, reqBodyMaker.addOtherPrimaryContract(userId, form), null, '新增同業壽險主約')
}

// 服務件列表
export const queryAllocationList = async(userId, conditions) => {
    if (AJADev) {
        return mock.queryAllocationList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1006/query`, reqBodyMaker.queryAllocationList(userId, conditions), null, '服務件列表')
}

// 新增同業壽險附約
export const addOtherAdditionalContract = async(userId, form, policyID) => {
    if (AJADev) {
        return mock.addOtherAdditionalContract
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_3010/post`, reqBodyMaker.addOtherAdditionalContract(userId, form, policyID), null, '新增同業壽險附約')
}

// 刪除同業壽險(刪主約:contractId不需傳 , 刪附約則都要傳)
export const deleteOtherContract = async(userId, personalId, policyId, contractId = null) => {
    if (AJADev) {
        return mock.deleteOtherContract
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_2030/delete`, reqBodyMaker.deleteOtherContract(userId, personalId, policyId, contractId), null, '刪除同業壽險')
}

//新增國泰壽險
export const addCathayInsurance = async(userId, insurances) => {
    // if(AJADev) {
    //   return mock.addCathayInsurance
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1001/query`, reqBodyMaker.addCathayInsurance(userId, insurances), null, '新增國泰壽險')
}


// 取得同業壽險保單之單張主約資訊
export const getPrimaryContractDetail = async(userId, policyId, contractId) => {
    if (AJADev) {
        return mock.getPrimaryContractDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_PRIMARY_CONTRACT_DETAIL_API/query`, reqBodyMaker.getPrimaryContractDetail(userId, policyId, contractId), null, '取得同業壽險保單之單張主約資訊')
}

// 取得同業壽險保單之單張附約資訊
export const getAdditionalContractDetail = async(userId, policyId, contractId) => {
    if (AJADev) {
        return mock.getAdditionalContractDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_ADDITIONAL_CONTRACT_DETAIL_API/query`, reqBodyMaker.getAdditionalContractDetail(userId, policyId, contractId), null, '取得同業壽險保單之單張附約資訊')
}

// 編輯同業壽險附約
export const modifyOtherAdditionalContract = async(userId, form, policyID, contractID, primaryContractId) => {
    if (AJADev) {
        return mock.modifyOtherAdditionalContract
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_3020/query`, reqBodyMaker.modifyOtherAdditionalContract(userId, form, policyID, contractID, primaryContractId), null, '編輯同業壽險附約')
}

// 編輯同業壽險主約
export const modifyOtherPrimaryContract = async(userId, form, policyID, contractID) => {
    if (AJADev) {
        return mock.modifyOtherPrimaryContract
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_2020/query`, reqBodyMaker.modifyOtherPrimaryContract(userId, form, policyID, contractID), null, '編輯同業壽險主約')
}

// 新增同業壽險車險
export const addMotorInsurances = async(userId, form) => {
    if (AJADev) {
        return mock.addMotorInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_4010/post`, reqBodyMaker.addMotorInsurances(userId, form), null, '新增同業壽險車險')
}

// 編輯同業壽險車險
export const editMotorInsurances = async(userId, form) => {
    if (AJADev) {
        return mock.editMotorInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_4020/put`, reqBodyMaker.editMotorInsurances(userId, form), null, '編輯同業壽險主約')
}

// 新增同業壽險火險
export const addFireInsurances = async(userId, form) => {
    if (AJADev) {
        return mock.addFireInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_5010/post`, reqBodyMaker.addFireInsurances(userId, form), null, '編輯同業壽險主約')
}

// 編輯同業壽險火險
export const editFireInsurances = async(userId, form) => {
    if (AJADev) {
        return mock.editFireInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_5020/put`, reqBodyMaker.editFireInsurances(userId, form), null, '編輯同業壽險主約')
}

// 新增同業壽險新種險
export const addNewTypeInsurances = async(userId, form) => {
    if (AJADev) {
        return mock.addNewTypeInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_6010/post`, reqBodyMaker.addNewTypeInsurances(userId, form), null, '編輯同業壽險主約')
}

// 編輯同業壽險新種險
export const editNewTypeInsurances = async(userId, form) => {
    if (AJADev) {
        return mock.editNewTypeInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_6020/put`, reqBodyMaker.editNewTypeInsurances(userId, form), null, '編輯同業壽險主約')
}

// 新增其他保單筆記
export const addOtherInsuranceNote = async(userId, form) => {
    if (AJADev) {
        return mock.addOtherInsuranceNote
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_7010/post`, reqBodyMaker.addOtherInsuranceNote(userId, form), null, '新增其他保單筆記')
}

// 編輯其他保單筆記
export const editOtherInsuranceNote = async(userId, form) => {
    if (AJADev) {
        return mock.editOtherInsuranceNote
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_7020/put`, reqBodyMaker.editOtherInsuranceNote(userId, form), null, '編輯其他保單筆記')
}

// 查詢同業壽險車、火、新種險
export const getAllInsurances = async(userId, custId) => {
        if (AJADev) {
            return mock.getAllInsurances
        }
        return await axiosWrap('Post', `/RestApiAdapter/MXC4_4000/query`, reqBodyMaker.getAllInsurances(userId, custId), null, '查詢同業壽險車、火、新種險')
    }
    // 查詢同業產險公司列表 
export const getAllCompany = async(userId, custId, serNo = null) => {
    if (AJADev) {
        return mock.getAllCompany
    }
    return await axiosWrap('Post', `/RestApiAdapter/OTHER_PROPERTY_GET_COMPANY_LIST/query`, reqBodyMaker.getAllCompany(userId, custId, serNo), null, '查詢同業產險公司列表')
}

// 查詢服務件地圖列表
export const getGoogleMapLocation = async(userId, formData) => {
        if (AJADev) {
            return mock.getGoogleMapLocation
        }
        return await axiosWrap('Post', `/RestApiAdapter/MXB1_1007/query`, reqBodyMaker.getGoogleMapLocation(userId, formData), null, '查詢服務件地圖列表')
    }
    // 刪除同業壽險列表
export const deleteOtherInsurances = async(userId, propertyId) => {
    if (AJADev) {
        return mock.deleteOtherInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_4030/delete`, reqBodyMaker.deleteOtherInsurances(userId, propertyId), null, '查詢服務件地圖列表')
}

// 查詢轄下撥出人員(小額調撥)
export const getOutTransferMember = async(userId, cedvno3, clcno5) => {
    if (AJADev) {
        return mock.getOutTransferMember
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1005/query`, reqBodyMaker.getOutTransferMember(userId, cedvno3, clcno5), null, '查詢轄下撥出人員(小額調撥)')
}

// 查詢轄下撥入人員(小額調撥)
export const getInTransferMember = async(userId, cedvno3, clcno5) => {
    if (AJADev) {
        return mock.getInTransferMember
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1005/query`, reqBodyMaker.getInTransferMember(userId, cedvno3, clcno5), null, '查詢轄下撥入人員(小額調撥)')
}

// 查詢拜訪紀錄自訂標籤
export const getCustVisitItem = async(userId) => {
    if (AJADev) {
        return mock.getCustVisitItem
    }
    return await axiosWrap('Post', `/RestApiAdapter/GET_CUSTOM_VISIT_ITEM_API/query`, reqBodyMaker.getCustVisitItem(userId), null, '查詢拜訪紀錄自訂標籤')
}

// 查詢拜訪紀錄固定標籤
export const getCustDefaultItem = async(userId) => {
    if (AJADev) {
        return mock.getCustDefaultItem
    }
    return await axiosWrap('Post', `/RestApiAdapter/QUERY_CLS_CODE_API/query`, reqBodyMaker.getCustDefaultItem(userId), null, '查詢拜訪紀錄固定標籤')
}

// 編輯拜訪紀錄
export const editVisitRecord = async(userId, custId, recordInfo, form, selectOpt) => {
    if (AJADev) {
        return mock.editVisitRecord
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_2020/process`, reqBodyMaker.editVisitRecord(userId, custId, recordInfo, form, selectOpt), null, '編輯拜訪紀錄')
}

// 刪除拜訪紀錄
export const deleteVisitRecord = async(userId, data) => {
    if (AJADev) {
        return mock.deleteOtherInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_2020/process`, reqBodyMaker.deleteVisitRecord(userId, data), null, '刪除拜訪紀錄')
}

// 編輯常用標籤
export const editCustItem = async(userId, form) => {
    if (AJADev) {
        return mock.editVisitRecord
    }
    return await axiosWrap('Post', `/RestApiAdapter/UPDATE_CUSTOM_VISIT_ITEM_API/put`, reqBodyMaker.editCustItem(userId, form), null, '編輯常用標籤')
}

// 查詢當日已覆核清單
export const getSPlList = async(userId, cedvno3) => {
    // if(AJADev) {
    //   return mock.getSPlList
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3004/process`, reqBodyMaker.getSPlList(userId, cedvno3), null, '查詢當日已覆核清單')
}

// 執行取消檔日已覆核
export const cancelSPl = async(userId, cedvno3, updateList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3004/process`, reqBodyMaker.cancelSPl(userId, cedvno3, updateList), null, '執行取消檔日已覆核')
}

// 覆核作業_查詢服務件調撥清單
export const getServiceTransferList = async(userId, div_no) => {
    // if(AJADev) {
    //   return mock.getServiceTransferList
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3006/query`, reqBodyMaker.getServiceTransferList(userId, div_no), null, '覆核作業_查詢服務件調撥清單')
}

// 覆核作業_取消覆核服務件調撥清單
export const reviewServiceTransferList = async(userId, reviewList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3006/review`, reqBodyMaker.reviewServiceTransferList(userId, reviewList), null, '覆核作業_取消覆核服務件調撥清單')
}

// 查詢前主管服務件自留清單
export const getFormerSupervisorServiceList = async(userId, div_no) => {
    // if(AJADev) {
    //   return mock.getFormerSupervisorServiceList
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3005/query`, reqBodyMaker.getFormerSupervisorServiceList(userId, div_no), null, '查詢前主管服務件自留清單')
}

// 覆核前主管服務件自留清單
export const reviewFormerSupervisorServiceList = async(userId, reviewList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3005/review`, reqBodyMaker.reviewFormerSupervisorServiceList(userId, reviewList), null, '覆核前主管服務件自留清單')
}

// 查詢疏遠件業務員清單
export const queryEstrangeAgList = async(userId, cedvno3) => {
    if (AJADev) {
        return mock.queryEstrangeAgList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3002/process`, reqBodyMaker.queryEstrangeAgList(userId, cedvno3), null, '查詢疏遠件業務員清單')
}

// 查詢疏遠件客戶清單
export const queryEstrangePlList = async(userId, cedvno3, ceclcno) => {
    if (AJADev) {
        return mock.queryEstrangePlList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3002/process`, reqBodyMaker.queryEstrangePlList(userId, cedvno3, ceclcno), null, '查詢疏遠件客戶清單')
}

// 覆核排除疏遠件
export const modifyEstrangePl = async(userId, cedvno3, dataList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3002/process`, reqBodyMaker.modifyEstrangePl(userId, cedvno3, dataList), null, '覆核排除疏遠件')
}

// 查詢準未訪_自招未訪件
export const queryUnvisitedList = async(userId, ceclcno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3002/process`, reqBodyMaker.queryUnvisitedList(userId, ceclcno), null, '查詢準未訪_自招未訪件')
}

// 覆核排除疏遠件
export const approveUnvisitedList = async(userId, cedvno3, dataList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3002/process`, reqBodyMaker.approveUnvisitedList(userId, cedvno3, dataList), null, '覆核準未訪_自招未訪件')
}

// 查詢轄下疏遠件人員
export const queryBelowEstrangeAg = async(userId, clcno_lv) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6001/query`, reqBodyMaker.queryBelowEstrangeAg(userId, clcno_lv), null, '查詢轄下疏遠件人員')
}

// 轄下疏遠件資訊
export const queryBelowEstrangePolicy = async(userId, ceclcid) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6001/query`, reqBodyMaker.queryBelowEstrangePolicy(userId, ceclcid), null, '轄下疏遠件資訊')
}

// 查詢轄下疏遠件資訊之保戶通聯資料IAA
export const queryBelowEstrangePolicyContactInfo = async(userId, ceapcno, ceapcnm) => {
    if (AJADev) {
        return mock.queryBelowEstrangePolicyContactInfo
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6002/query`, reqBodyMaker.queryBelowEstrangePolicyContactInfo(userId, ceapcno, ceapcnm), null, '轄下疏遠件資訊之保戶通聯資料')
}

// 覆核小額調撥_取得未覆核名單
export const queryNreChargeList = async(userId, mktdeptno, action) => {
    if (AJADev) {
        return mock.queryNreChargeList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3001/query`, reqBodyMaker.queryNreChargeList(userId, mktdeptno, action), null, '覆核小額調撥_取得未覆核名單')
}

// 覆核小額調撥_確認覆核
export const confirmNreCharge = async(userId, userName, data, mktdeptno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3001/process`, reqBodyMaker.confirmNreCharge(userId, userName, data, mktdeptno), null, '覆核小額調撥_確認覆核')
}

// 覆核小額調撥_退回覆核
export const delNreCharge = async(userId, ceplcno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3001/delete`, reqBodyMaker.deleteNreCharge(userId, ceplcno), null, '覆核小額調撥_退回覆核')
}

// 查詢覆核失聯件排除
export const queryChangeNcontact = async(userId, clcno_lv, startDate, endDate) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3000/query`, reqBodyMaker.queryChangeNcontact(userId, clcno_lv, startDate, endDate), null, '查詢覆核失聯件排除')
}

// 覆核更新失聯件
export const updateChangeNcontact = async(userId, visitNoArray) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3000/update`, reqBodyMaker.updateChangeNcontact(userId, visitNoArray), null, '覆核更新失聯件')
}

// 服務件_NAP_查詢
export const queryForNAPServiceData = async(userId, divNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_7001/query`, reqBodyMaker.queryForNAPServiceData(userId, divNo), null, '服務件-給NAP的API')
}

// 查詢調撥記錄清單
export const queryRechargeRecord = async(userId, cedvno3, api_id, cedvno3_out, cedvno3_in) => {
    if (AJADev) {
        return mock.queryRechargeRecord
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2000/query`, reqBodyMaker.queryRechargeRecord(userId, cedvno3, api_id, cedvno3_out, cedvno3_in), null, '查詢調撥記錄清單')
}

// 查詢調撥記錄名細
export const queryRechargeRecordDetail = async(userId, ceclcid_old, ceclcno_old, ceclcid_new, ceclcno_new, producer_segment, date) => {
    if (AJADev) {
        return mock.queryRechargeRecordDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2000/query`, reqBodyMaker.queryRechargeRecordDetail(userId, ceclcid_old, ceclcno_old, ceclcid_new, ceclcno_new, producer_segment, date), null, '查詢調撥記錄名細')
}

// 服務件調撥寫入記錄
export const insertServiceRecord = async(userId, type, policyList, AgInfo, clcno, userName) => {
    if (AJADev) {
        return mock.editVisitRecord
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1008/process`, reqBodyMaker.insertServiceRecord(userId, type, policyList, AgInfo, clcno, userName), null, '服務件調撥寫入記錄')
}

// 服務件調撥寫入記錄(智能配對)
export const insertServiceRecord2 = async(userId, selection, userName) => {
    // if (AJADev) {
    //     return mock.editVisitRecord
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1008/process2`, reqBodyMaker.insertServiceRecord2(userId, selection, userName), null, '服務件調撥寫入記錄(智能配對)')
}

// 刪除國泰壽險
export const deleteCathayInsurance = async(userId, insurances) => {
    if (AJADev) {
        return mock.deleteOtherInsurances
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1030/delete`, reqBodyMaker.deleteCathayInsurance(userId, insurances), null, '刪除國泰壽險')
}

// 查詢搜尋紀錄前八筆
export const getSearchRecordFirstEight = async(userId) => {
    if (AJADev) {
        return mock.getSearchRecordFirstEight
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXL0_0000/query`, reqBodyMaker.getSearchRecordFirstEight(userId), null, '查詢搜尋紀錄前八筆')
}

// 查詢拜訪件人員
export const queryChangeNEag = async(userId, divNo) => {
    //原 
    //return await axiosWrap('Post', `/RestApiAdapter/MXB1_3003/query_Eag`, reqBodyMaker.queryChangeNEag(userId, divNo), null, '查詢拜訪件人員')
    //sp13修改
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3003/query_Eag`, reqBodyMaker.queryChangeNEag(userId, divNo), null, '查詢拜訪件人員')
}

// 查詢拜訪排除
export const queryChangeNIsexc = async(userId, divNo, starDay, endDay, clcno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3003/query_Isexc`, reqBodyMaker.queryChangeNIsexc(userId, divNo, starDay, endDay, clcno), null, '查詢拜訪排除')
}

// 更新拜訪排除
export const updateChangeNIsexc = async(userId, visitNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_3003/process`, reqBodyMaker.updateChangeNIsexc(userId, visitNo), null, '更新拜訪排除')
}

// 建議調撥(全單位疏遠件)
// lev1:全部, (yearq, monq)
// lev2:區部, (yearq, monq, cedvno)
// lev3:通訊處, (yearq, monq, cedvno)
// lev44:展業課, (cedvno)
// lev51:專招推展處, (cedvno)
// lev54:展業區, (cedvno)
// lev6:人員, (cedvno)
export const queryStatsBZ = async(userId, level, westYear, month, cedvno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6000/query`, reqBodyMaker.queryStatsBZ(userId, level, westYear, month, cedvno), null, '建議調撥(全單位疏遠件)')
}

//下載建議調撥(全單位疏遠件)
export const downloadStatsBZ = async(userId, level, westYear, month, cedvno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6000/download`, reqBodyMaker.downloadStatsBZ(userId, level, westYear, month, cedvno), 'blob', '下載建議調撥(全單位疏遠件)')
}


// 轄下疏遠件接觸追蹤表
// lev1:全部, (yearq, monq)
// lev2:區部, (yearq, monq, cedvno)
// lev3:通訊處, (yearq, monq, cedvno)
// lev44:展業課, (yearq, monq, cedvno)
// lev51:專招推展處, (yearq, monq, cedvno)
// lev54:展業區, (yearq, monq, cedvno)
// lev6:人員, (yearq, monq, cedvno)
export const queryStatsBZEST = async(userId, level, startDate, endDate, cedvno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6004/query`, reqBodyMaker.queryStatsBZEST(userId, level, startDate, endDate, cedvno), null, '轄下疏遠件接觸追蹤表')
}

export const downloadStatsBZEST = async(userId, level, startDate, endDate, cedvno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6004/download`, reqBodyMaker.downloadStatsBZEST(userId, level, startDate, endDate, cedvno), 'blob', '轄下疏遠件接觸追蹤表')
}

// 查詢覆核記錄
export const queryApproveRecord = async(userId, cedvno3) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2001/query`, reqBodyMaker.queryApproveRecord(userId, cedvno3), null, '查詢覆核記錄')
}

// 查詢失聯件覆核明細
export const queryLostConfirmDetail = async(userId, agid, csid, clcno, cdate) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2001/query`, reqBodyMaker.queryLostConfirmDetail(userId, agid, csid, clcno, cdate), null, '查詢失聯件覆核明細')
}

// 查詢實質接觸排除明細
export const queryNoticeExcludeDetail = async(userId, agid, csid, clcno, cdate, cedvno3) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2001/query`, reqBodyMaker.queryNoticeExcludeDetail(userId, agid, csid, clcno, cdate, cedvno3), null, '查詢實質接觸排除明細')
}

// 查詢疏遠件排除明細
export const queryEstrangeExcludeDetail = async(userId, agid, csid, clcno, cdate) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2001/query`, reqBodyMaker.queryEstrangeExcludeDetail(userId, agid, csid, clcno, cdate), null, '查詢覆核記錄')
}

//「回到舊CRM」寫Log
export const insertOldCRMLoginLog = async(userId, depno, divno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_2002/process`, reqBodyMaker.insertOldCRMLoginLog(userId, depno, divno), null, '建議調撥(全單位疏遠件)')
}

// 取回所有單位代號及對象總人數
export const getTacount = async(userId, report) => {
    if (AJADev) {
        return mock.getTacount
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB4_1010/query`, reqBodyMaker.getTacount(userId, report), null, '取回所有單位代號及對象總人數')
}

// 單位佈告欄-新增訊息
export const releaseAddNews = async(userId, formData, file) => {
    // if(AJADev) {
    //   return mock.releaseAddNews
    // }
    return await axiosFormData('Post', `/RestApiAdapter/MXB4_1010/process`, reqBodyMaker.releaseAddNews(userId, formData, file), null, '單位佈告欄-新增訊息')
}

// 查異動後實質接觸-查詢名細
export const getChangeNotice = async(userId, asc) => {
    if (AJADev) {
        return mock.getChangeNotice
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.getChangeNotice(userId, asc), null, '查異動後實質接觸-查詢名細')
}

// 查異動後實質接觸-查詢名細(by csid)
export const getChangeNotice_csid = async(userId, custids) => {
    if (AJADev) {
        return mock.getChangeNotice_csid
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.getChangeNotice_csid(userId, custids), null, '查異動後實質接觸-查詢名細(by csid)')
}

// 查詢是否有異動後實質接觸名細
export const checkNotice = async(agid, csid) => {
    //if(AJADev) {
    //return mock.getChangeNotice
    //}
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.checkNotice(agid, csid), null, '查詢是否有異動後實質接觸名細')
}

//公版聯繫函_查詢(聯繫關係、客戶資訊、單位資訊)
export const contactLetter = async(api_id, agid, csid, cedvno) => {
    let stringInfo = "公版聯繫函_查詢";
    if(api_id === "8"){
        stringInfo = "公版聯繫函_查詢聯繫關係";
    } else if(api_id === "9"){
        stringInfo = "公版聯繫函_查詢客戶資訊";
    } else if(api_id === "10"){
        stringInfo = "公版聯繫函_查詢單位資訊";
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.contactLetter(api_id, agid, csid, cedvno), null, stringInfo)
}

//公版聯繫函-列印
export const showContactLetterPDF = async(userId, param) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/showContactLetterPDF`, reqBodyMaker.showChangePDF(userId, param), null, '公版聯繫函-列印')
}

// 查異動後實質接觸-查詢列印
export const getChangePrint = async(userId, custId, visitNo, cedvno) => {
    // if(AJADev) {
    //   return mock.getChangePrint
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.getChangePrint(userId, custId, visitNo, cedvno), null, '查異動後實質接觸-查詢列印')
}

// 查異動後實質接觸-查詢列印(多筆))
export const getChangePrint_all = async(userId, custId, visitNo, cedvno) => {
    // if(AJADev) {
    //   return mock.getChangePrint_all
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.getChangePrint_all(userId, custId, visitNo, cedvno), null, '查異動後實質接觸-查詢列印(多筆)')
}

// 異動後實質接觸-列印
export const showChangePDF = async(userId, param) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/showPDF`, reqBodyMaker.showChangePDF(userId, param), null, '異動後實質接觸-列印')
}

// 查異動後實質接觸-查詢回報
export const getChangeReprot = async(userId, visitNo) => {
    if (AJADev) {
        return mock.getChangeReprot
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.getChangeReprot(userId, visitNo), null, '查異動後實質接觸-查詢回報')
}

// 查異動後實質接觸-更新回報
export const getChangeUpdateReprot = async(userId, custId, contact) => {
    if (AJADev) {
        return mock.getChangeUpdateReprot
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_22001/process`, reqBodyMaker.getChangeUpdateReprot(userId, custId, contact), null, '查異動後實質接觸-更新回報')
}

//辦理集彙件提醒
export const getHandleGroupRemittanceNotification = async(userId, custId, contact) => {
    if (AJADev) {
        return mock.getHandleGroupRemittanceNotification
    }
}

// 停效保單
export const getStopEffect = async(userId, custId, contact) => {
    if (AJADev) {
        return mock.getStopEffect
    }
}

// 實支實付
export const getRealPaid = async(userId, custId, contact) => {
    if (AJADev) {
        return mock.getRealPaid
    }
}


// 單位佈告欄-點閱率查詢
export const queryClickRate = async(userId, divno) => {
    if (AJADev) {
        return mock.queryClickRate
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB4_1000/queryAllNews`, reqBodyMaker.queryClickRate(userId, divno), null, '單位佈告欄-查詢點閱率')
}

// 單位佈告欄-已下架點閱率查詢
export const queryOldClickRate = async(userId, divno, startDate, endDate, subjectKeyWord) => {
    if (AJADev) {
        return mock.queryOldClickRate
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB4_1000/queryOldNews`, reqBodyMaker.queryOldClickRate(userId, divno, startDate, endDate, subjectKeyWord), null, '單位佈告欄-已下架點閱率查詢')
}

// 單位佈告欄-編輯訊息
export const modifyNews = async(userId, form) => {
    // if(AJADev) {
    //   return mock.modifyNews
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB4_1020/process`, reqBodyMaker.modifyNews(userId, form), null, '單位佈告欄-編輯訊息')
}

// 單位佈告欄-直接下架
export const downNews = async(userId, form) => {
    // if(AJADev) {
    //   return mock.modifyNews
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB4_1020/processDown`, reqBodyMaker.modifyNews(userId, form), null, '單位佈告欄-直接下架')
}


//最新消息_LOG
export const insertNewsLog = async(userId, ceadcd, div_no, ser_no, isclicktitle, islinkway) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_3001/process`, reqBodyMaker.insertNewsLog(userId, ceadcd, div_no, ser_no, isclicktitle, islinkway), null, '最新消息_LOG')
}

// 名單專區-首頁資訊
export const getListArea = async(userId) => {
    if (AJADev) {
        return mock.getListArea
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_0000/query`, reqBodyMaker.getListArea(userId), null, '名單專區-首頁資訊')
}

// 新增首頁查詢關鍵字的Log
export const setKeyWordLog = async(userId, searchkeyword) => {
    if (AJADev) {
        return mock.setKeyWordLog
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_4001/process`, reqBodyMaker.setKeyWordLog(searchkeyword), null, '新增首頁查詢關鍵字的Log')
}

// 新增滿意度調查
export const setSatisfactionSurvey = async(userId, cate_serno, satisfy_range, recommand_txt) => {
    // if(AJADev) {
    //   return mock.setSatisfactionSurvey
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_5000/process`, reqBodyMaker.setSatisfactionSurvey(userId, cate_serno, satisfy_range, recommand_txt), null, '新增滿意度調查')
}

// 查詢是否完成滿意度調查
export const isSatisfactionSurveyFinish = async(userId, cate_serno) => {
    if (AJADev) {
        return mock.isSatisfactionSurveyFinish
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_5000/query`, reqBodyMaker.isSatisfactionSurveyFinish(userId, cate_serno), null, '查詢是否完成滿意度調查')
}

// 查詢強制調撥總表
export const getmandatoryAllocationSummary = async(userId, api_id, report) => {
    if (AJADev) {
        return mock.getmandatoryAllocationSummary
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_4000/query`, reqBodyMaker.getmandatoryAllocationSummary(userId, api_id, report), null, '查詢強制調撥總表')
}

// 強制調撥離退職人員撥出
export const forcedTransferPersonnel = async(userId, api_id, report) => {
    if (AJADev) {
        return mock.forcedTransferPersonnel
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_4001/query`, reqBodyMaker.forcedTransferPersonnel(userId, api_id, report), null, '強制調撥離退職人員撥出')
}

// 名單專區各個首頁資訊
export const getCategoryInfo = async(userId, categor) => {
    if (AJADev) {
        if (categor == '精準行銷') {
            return mock.getCategoryInfoA
        } else if (categor == '集團相關') {
            return mock.getCategoryInfoB
        } else if (categor == '服務/權益') {
            return mock.getCategoryInfoC
        } else if (categor == '整合行銷') {
            return mock.getCategoryInfoD
        }
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_0001/query`, reqBodyMaker.getCategoryInfo(userId, categor), null, `名單專區各個首頁資訊-${categor}`)
}

// 取得專區資訊
export const getCategoryDetail = async(userId, ser_no) => {
    if (AJADev) {
        if (ser_no == '001') {
            return mock.getCategoryDetail001
        } else if (ser_no == '002') {
            return mock.getCategoryDetail002
        } else if (ser_no == '003') {
            return mock.getCategoryDetail003
        } else if (ser_no == '023') {
            return mock.getCategoryDetail023
        } else if (ser_no == '030') {
            return mock.getCategoryDetail030
        } else if (ser_no == '031') {
            return mock.getCategoryDetail031
        } else if (ser_no == '032') {
            return mock.getCategoryDetail032
        }
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_0002/query`, reqBodyMaker.getCategoryDetail(userId, ser_no), null, '取得專區資訊')
}

//查詢舊拜訪紀錄
export const queryOldCRMRecord = async(userId, csid) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_4010/query`, reqBodyMaker.queryOldCRMRecord(userId, csid), null, '查詢舊拜訪紀錄')
}

//查詢單位佈告欄成效檢視
export const queryUnitBulletinEffect = async(userId, report) => {
    if (AJADev) {
        return mock.queryUnitBulletinEffect
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB4_2000/query`, reqBodyMaker.queryUnitBulletinEffect(userId, report), null, '查詢單位佈告欄成效檢視')
}

// 取得異動後實質接觸追蹤表
export const getChangeTrace = async(userId, api_id, is_vip, start_date, end_date, group) => {
    if (AJADev) {
        return mock.getChangeTrace
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_5000/query`, reqBodyMaker.getChangeTrace(userId, api_id, is_vip, start_date, end_date, group), null, '取得異動後實質接觸追蹤表')
}

// 取得異動後實質接觸追蹤表KEEP
export const getChangeTraceKeep = async(userId, api_id, is_vip, start_date, end_date, group) => {
    if (AJADev) {
        return mock.getChangeTrace
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_5002/query`, reqBodyMaker.getChangeTrace(userId, api_id, is_vip, start_date, end_date, group), null, '取得異動後實質接觸追蹤表KEEP')
}

// 轄下異動後實質接觸人員
export const getChangePeople = async(userId, clcno_lv) => {
    if (AJADev) {
        return mock.getChangePeople
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_5001/query`, reqBodyMaker.getChangePeople(userId, clcno_lv), null, '轄下異動後實質接觸人員')
}

// 轄下異動後實質接觸明細
export const getChangeDetail = async(userId, cedvno3, clcno_lv, start_date, end_date, clcid, is_vip) => {
    if (AJADev) {
        return mock.getChangeDetail
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_5001/query`, reqBodyMaker.getChangeDetail(userId, cedvno3, clcno_lv, start_date, end_date, clcid, is_vip), null, '轄下異動後實質接觸明細')
}

// 查詢受益量多名單
export const getMoreBenefits = async(userId) => {
    if (AJADev) {
        return mock.getMoreBenefits
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/query`, reqBodyMaker.getMoreBenefits(userId), null, '查詢受益量多名單')
}

// 查詢受益量多名單(潛力新客)
export const getHighPotentialNewCustomer = async(userId, serNo) => {
    if (AJADev) {
        return mock.getMoreBenefits
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/queryBoxCustomer`, reqBodyMaker.getHighPotentialNewCustomer(userId, serNo), null, '查詢受益量多名單(潛力新客)')
}

// 查詢缺醫不可名單
export const getMedicalCare = async(userId, serNo) => {
    if (AJADev) {
        return mock.getMedicalCare
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/queryBoxCustomer`, reqBodyMaker.getMedicalCare(userId, serNo), null, '查詢缺醫不可名單')
}

// 查詢三倍醫靠名單
export const getTripleCare = async(userId, serNo) => {
    if (AJADev) {
        return mock.getTripleCare
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/queryBoxCustomer`, reqBodyMaker.getTripleCare(userId, serNo), null, '查詢三倍醫靠名單')
}

// 查詢商品行銷客戶名單
export const queryBoxCustomer = async(userId, serNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/queryBoxCustomer`, reqBodyMaker.queryBoxCustomer(userId, serNo), null, '查詢商品行銷客戶名單')
}

// 查詢商品行銷事件偵測名單
export const queryEventDetection = async(userId, serNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2237/queryEventDetection`, reqBodyMaker.queryBoxCustomer(userId, serNo), null, '查詢商品行銷事件偵測名單')
}

// 查詢一件鐘情名單
export const getOneLove = async(userId) => {
    if (AJADev) {
        return mock.getOneLove
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/query`, reqBodyMaker.getOneLove(userId), null, '查詢一件鐘情名單')
}

//2年內新人AFP/FCP撥入
export const newcomerDialinWithin = async(userId, api_id, report) => {
    if (AJADev) {
        return mock.newcomerDialinWithin
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_4002/query`, reqBodyMaker.newcomerDialinWithin(userId, api_id, report), null, '2年內新人AFP/FCP撥入')
}

//查詢轄下服務件資訊
export const queryNrechargeInfo = async(userId, api_id, group, cedvno, ceadcd, roleId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6003/query`, reqBodyMaker.queryNrechargeInfo(userId, api_id, group, cedvno, ceadcd, roleId), null, '查詢轄下服務件資訊')
}

// 下載轄下服務件資訊
export const downloadNrechargeInfo = async(userId, api_id, roleId, group, cedvno, ceadcd) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6003/download`, reqBodyMaker.downloadNrechargeInfo(userId, api_id, roleId, group, cedvno, ceadcd), 'blob', '下載轄下服務件資訊')
}

// 下載轄下服務件資訊(區處)
export const downloadNrechargeInfo2 = async(userId, roleId, cedvno, api_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6003/download2`, reqBodyMaker.downloadNrechargeInfo2(userId, roleId, cedvno, api_id), 'blob', '下載轄下服務件資訊(類別)')
}

// 下載區部未訪件資訊
export const downloadRegionalUnvisitedInfo = async(userId, cedvno3, api_id, segmentName) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1012/download`, reqBodyMaker.downloadRegionalUnvisitedInfo(userId, cedvno3, api_id, segmentName), 'blob', '下載區部未訪件資訊')
}

//單位條件篩選-查詢條件發佈後的使用狀況
export const queryconditions = async(userId, divno) => {
    if (AJADev) {
        return mock.queryconditions
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB5_1000/query`, reqBodyMaker.queryconditions(userId, divno), null, '查詢條件發佈後的使用狀況')
}

//全單位疏遠件
export const allUnitdetachment = async(userId, api_id, report) => {
    if (AJADev) {
        return mock.allUnitdetachment
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_4003/query`, reqBodyMaker.allUnitdetachment(userId, api_id, report), null, '全單位疏遠件')
}

//單位條件篩選-查詢已下架的單位條件
export const queryoffconditions = async(userId, divno, start_date, end_date) => {
        return await axiosWrap('Post', `/RestApiAdapter/MXB5_1000/queryOff`, reqBodyMaker.queryoffconditions(userId, divno, start_date, end_date), null, '單位條件篩選-查詢已下架的單位條件')
    }
    // 調撥進度查詢
export const allocationStatusProcess = async(userId, agid, api_id, plcno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_2002/process`, reqBodyMaker.allocationStatusProcess(userId, agid, api_id, plcno), null, '調撥進度查詢')
}

// 新增單位條件篩選
export const inserUnitCondition = async(userId, reprotData) => {
    // if(AJADev) {
    //   return mock.inserUnitCondition
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB5_1010/post`, reqBodyMaker.inserUnitCondition(userId, reprotData), null, '新增單位條件篩選')
}

// 客戶數預覽
export const getUnitCustCount = async(userId, divno, reprotData) => {
    if (AJADev) {
        return mock.getUnitCustCount
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB5_1011/query`, reqBodyMaker.getUnitCustCount(userId, divno, reprotData), null, '客戶數預覽')
}

// 編輯單位條件
export const modifyCondition = async(userId, end_date, devfilter_name, serno, upload_date) => {
    // if(AJADev) {
    //   return mock.modifyCondition
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXB5_1020/process`, reqBodyMaker.modifyCondition(userId, end_date, devfilter_name, serno, upload_date), null, '編輯單位條件')
}

// 單位條件_成效檢視
export const getEffective = async(userId, showclass, devno, serNo) => {
        if (AJADev) {
            if (showclass == "0") {
                return mock.getEffective
            } else {
                return mock.getEffective1
            }
        }
        return await axiosWrap('Post', `/RestApiAdapter/MXB5_1001/query`, reqBodyMaker.getEffective(userId, showclass, devno, serNo), null, '單位條件_成效檢視')
    }
    // 精準行銷-特定專案推動-實支實付目標客戶
export const getRealPaying = async(userId) => {
    if (AJADev) {
        return mock.getRealPaying
    }
    //return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/query`, reqBodyMaker.getOneLove(userId), null, '查詢一件鐘情名單')
}

// 服務權益-VIP專區-尊榮服務(符合資格)
export const getHonorService = async(userId) => {
    if (AJADev) {
        return mock.getHonorService
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2210/query`, reqBodyMaker.getHonorService(userId), null, '服務權益-VIP專區-尊榮服務(符合資格)')
}

// 服務權益-VIP專區-推動名單(升/降等)
export const getPushList = async(userId) => {
    if (AJADev) {
        return mock.getPushList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2211/query`, reqBodyMaker.getPushList(userId), null, 'VIP專區-推動名單(升/降等)')
}

// 服務權益-VIP專區-迎賓禮(符合資格)
export const getWelcomeCeremony = async(userId) => {
    if (AJADev) {
        return mock.getWelcomeCeremony
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2212/query`, reqBodyMaker.getWelcomeCeremony(userId), null, '服務權益-VIP專區-迎賓禮(符合資格)')
}

// 服務權益-VIP專區-健康禮(符合資格) 
export const getHealthCeremony = async(userId) => {
    if (AJADev) {
        return mock.getHealthCeremony
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2213/query`, reqBodyMaker.getHealthCeremony(userId), null, '服務權益-VIP專區-健康禮(符合資格)')
}

// 服務權益-保單活化查詢 
export const getInsuranceActivation = async(userId) => {
    if (AJADev) {
        return mock.getHealthCeremony
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_4001/query`, reqBodyMaker.getInsuranceActivation(userId), null, '服務權益-保單活化查詢')
}

// 服務權益-易Call保待重簽名單查詢 
export const getEcllServiceItem = async(userId) => {
    if (AJADev) {
        return mock.getHealthCeremony
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2219/query`, reqBodyMaker.getEcllServiceItem(userId), null, '服務權益-易Call保待重簽名單查詢')
}

// 服務權益-VIP專區-國泰一家人(家庭服務)
export const getCathayFamily = async(userId) => {
    if (AJADev) {
        return mock.getCathayFamily
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2214/process`, reqBodyMaker.getCathayFamily(userId), null, '服務權益-VIP專區-國泰一家人(家庭服務)')
}

// 服務權益-VIP專區-國泰一家人(家庭服務)列印
export const getCathayFamilyPrint = async(userId) => {
    if (AJADev) {
        return mock.getCathayFamilyPrint
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2214/process`, reqBodyMaker.getCathayFamilyPrint(userId), null, '服務權益-VIP專區-國泰一家人(家庭服務)列印')
}

// 服務權益-VIP專區-國泰一家人(健康優禮)
export const getCathayFamilyPresent = async(userId, csid, csname) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2214/process`, reqBodyMaker.getCathayFamilyPresent(userId, csid, csname), null, '服務權益-VIP專區-國泰一家人(健康優禮)')
}

// 服務權益-VIP專區-國泰一家人(權益服務)
export const getCathayFamilyBenefits = async(userId, csid) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2214/process`, reqBodyMaker.getCathayFamilyBenefits(userId, csid), null, '服務權益-VIP專區-國泰一家人(權益服務)')
}

// 服務權益-VIP專區-免費健檢(符合資格)
export const getFreeHealthCheck = async(userId) => {
    if (AJADev) {
        return mock.getFreeHealthCheck
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2215/query`, reqBodyMaker.getFreeHealthCheck(userId), null, '服務權益-VIP專區-免費健檢(符合資格)')
}

// 服務權益-停效保單查詢
export const getStopEffctivePolicy = async(userId) => {
    if (AJADev) {
        return mock.getStopEffctivePolicy
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2221/query`, reqBodyMaker.getStopEffctivePolicy(userId), null, '服務權益-停效保單查詢')
}

// 名單專區_滿期年金未辦
export const getFullAnnuityNotHandle = async(userId) => {
    if (AJADev) {
        return mock.getFullAnnuityNotHandle
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2216/query`, reqBodyMaker.getFullAnnuityNotHandle(userId), null, '名單專區_滿期年金未辦')
}

// 名單專區-未兌現支票
export const getUnpaidCheck = async(userId) => {
    if (AJADev) {
        return mock.getUnpaidCheck
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2217/query`, reqBodyMaker.getUnpaidCheck(userId), null, '名單專區-未兌現支票')
}
// 名單專區-公教長照
export const getLongTermCare = async(userId) => {
    if (AJADev) {
        return mock.getLongTermCare
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getLongTermCare(userId), null, '名單專區-公教長照')
}
// 名單專區-線上諮詢
export const getOnlineConsultation = async(userId) => {
    // if(AJADev) {
    //   return mock.getOnlineConsultation
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getOnlineConsultation(userId), null, '名單專區-線上諮詢')
}

// 名單專區-約定扣款獎勵活動
export const getAgreedDeduction = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2239/query`, reqBodyMaker.getAgreedDeduction(userId), null, '名單專區-約定扣款獎勵活動')
}

// 名單專區-約定扣款獎勵活動要保人目標保單明細
export const getAgreedDeductionDetail = async(userId,apcId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2239/detail`, reqBodyMaker.getAgreedDeductionDetail(userId,apcId), null, '名單專區-約定扣款獎勵活動要保人目標保單明細')
}

// 名單專區-外幣匯款手續費優惠
export const getForeignCurrencyHandleDiscount = async(userId) => {
    if (AJADev) {
        return mock.getForeignCurrencyHandleDiscount
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3001/query`, reqBodyMaker.getForeignCurrencyHandleDiscount(userId), null, '名單專區-外幣匯款手續費優惠')
}
// 名單專區-即將停效
export const getWillStopEffect = async(userId) => {
    if (AJADev) {
        return mock.getWillStopEffect
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/query`, reqBodyMaker.getWillStopEffect(userId), null, '名單專區-即將停效')
}

// 名單專區-停效後半年
export const getStopEffectAfter = async(userId) => {
    if (AJADev) {
        return mock.getStopEffectAfter
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/query`, reqBodyMaker.getStopEffectAfter(userId), null, '名單專區-停效後半年')
}

// 名單專區-保單給付應領未領
export const getWarrantyShouldReceiveNotReceive = async(userId) => {
    if (AJADev) {
        return mock.getWarrantyShouldReceiveNotReceive
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2218/query`, reqBodyMaker.getWarrantyShouldReceiveNotReceive(userId), null, '名單專區-保單給付應領未領')
}

// 名單專區-滿期目標客戶
export const getFullTargetCustom = async(userId) => {
    if (AJADev) {
        return mock.getFullTargetCustom
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3201/queryCrm`, reqBodyMaker.getFullTargetCustom(userId), null, '名單專區-滿期目標客戶')
}

// 名單專區-年金目標客戶
export const getAnnuityTargetCustom = async(userId) => {
    if (AJADev) {
        return mock.getAnnuityTargetCustom
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2220/query`, reqBodyMaker.getAnnuityTargetCustom(userId), null, '名單專區-年金目標客戶')
}

// 名單專區-通訊資料自清專案
export const getInfoAdjustment = async(userId, asc) => {
    if (AJADev) {
        return mock.getInfoAdjustment
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2227/query`, reqBodyMaker.getInfoAdjustment(userId, asc), null, '名單專區-客戶資料校正專案')
}

// 名單專區-停效關懷專案
export const getSuspensionCare = async(userId, asc) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2229/query`, reqBodyMaker.getSuspensionCare(userId, asc), null, '名單專區-停效關懷專案')
}

//更新該cust停效關懷專案拜訪結果
export const updateVisitResult = async(userId, reportData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2229/update`, reqBodyMaker.updateVisitResult(userId, reportData), null, '更新停效關懷專案拜訪結果 ')
}

//更新該cust通訊資料自清專案已拜訪說明 (通訊資料自清專案)
export const updateVisit = async(userId, divNo, reportData) => {
    if (AJADev) {
        return mock.updateVisit
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2227/update`, reqBodyMaker.updateVisit(userId, divNo, reportData), null, '更新該cust通訊資料自清專案已拜訪說明')
}

//更新該cust通訊資料自清專案未拜訪說明 (通訊資料自清專案)
export const updateUnVisit = async(userId, divNo, reportData) => {
    if (AJADev) {
        return mock.updateUnVisit
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2227/update`, reqBodyMaker.updateUnVisit(userId, divNo, reportData), null, '更新該cust通訊資料自清專案未拜訪說明 ')
}

// 名單專區-疏遠件預警
export const getRemoteDocumentWarning = async(userId, apiID) => {
    // if(AJADev) {
    //   return mock.getRemoteDocumentWarning
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2001/query`, reqBodyMaker.getRemoteDocumentWarning(userId, apiID), null, apiID == '1' ? '名單專區-疏遠件預警' : '名單專區-準未訪件明細')
}


// 名單專區-疏遠件預警-是否失聯(儲存)
export const getRemoteDocumentWarningLost = async(userId, ceapcno, contact, isRemote) => {
    // if(AJADev) {
    //   return mock.getRemoteDocumentWarningLost
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2001/query`, reqBodyMaker.getRemoteDocumentWarningLost(userId, ceapcno, contact, isRemote), null, isRemote ? '名單專區-疏遠件預警-是否失聯(儲存)' : '名單專區-準未訪件明細-是否失聯(儲存)')
}

// 名單專區-身心障礙
export const getPhysicalMentalDisorder = async(userId) => {
    if (AJADev) {
        return mock.getPhysicalMentalDisorder
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getPhysicalMentalDisorder(userId), null, '名單專區-身心障礙')
}

// 名單專區-小額終老
export const getSmallAmountOldAge = async(userId) => {
    if (AJADev) {
        return mock.getSmallAmountOldAge
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getSmallAmountOldAge(userId), null, '名單專區-小額終老')
}

// 名單專區-樂安心保
export const getHappyMindInsurance = async(userId) => {
    if (AJADev) {
        return mock.getHappyMindInsurance
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getHappyMindInsurance(userId), null, '名單專區-樂安心保')
}

// 名單專區-國泰伴你健康
export const getCathayWithYourHealth = async(userId) => {
    // if(AJADev) {
    //   return mock.getCathayWithYourHealth
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getCathayWithYourHealth(userId), null, '名單專區-國泰伴你健康')
}

// 名單專區-證卷數位服務
export const getSecuritiesDigitalService = async(userId) => {
    // if(AJADev) {
    //   return mock.getSecuritiesDigitalService
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getSecuritiesDigitalService(userId), null, '名單專區-證卷數位服務')
}

// 名單專區-高資產複委託
export const getHighAssetsRedelegation = async(userId) => {
    // if(AJADev) {
    //   return mock.getHighAssetsRedelegation
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1002/query`, reqBodyMaker.getHighAssetsRedelegation(userId), null, '名單專區-高資產複委託')
}

//單位條件篩選_直接下架
export const conditionDown = async(userId, downData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB5_1020/processDown`, reqBodyMaker.conditionDown(userId, downData), null, '單位條件篩選_直接下架')
}

//授權管理_查詢轄下可授權人員
export const getAuthorizedPersonnel = async(userId, divno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB6_1000/query`, reqBodyMaker.getAuthorizedPersonnel(userId, divno), null, '授權管理_查詢轄下可授權人員')
}

//授權管理_設定權限
export const setPermissionsAuthorized = async(userId, form, lists) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB6_1000/process`, reqBodyMaker.setPermissionsAuthorized(userId, form, lists), null, '授權管理_設定權限')
}

// 最新消息下載檔案
export const downloadFile = async(userId, ser_no, filename) => {
    // if(AJADev) {
    //   return mock.downloadFile
    // }
    return await axiosWrap('Post', `/RestApiAdapter/INDEX_DOWNLOAD_FILE_API/download`, reqBodyMaker.downloadFile(userId, ser_no, filename), 'blob', '最新消息下載檔案')
}

// 下載服務件調撥操作手冊
export const downloadFile_m0 = async(userId, ser_no, filename) => {
    // if(AJADev) {
    //   return mock.downloadFile_m0
    // }
    return await axiosWrap('Post', `/RestApiAdapter/DOWNLOAD_FILE_API2/downloadFile_m0`, reqBodyMaker.downloadFile_m0(userId, ser_no, filename), 'blob', '下載服務件調撥操作手冊')
}

// EMAIL 寄送邀請函
export const invitation_SendEmail = async(userId, data, type) => {
    // if(AJADev) {
    //   return mock.invitation_SendEmail
    // }
    return await axiosWrap('Post', `/RestApiAdapter/INVITATION_SENDMAIL_API/invitation_SendEmail`, reqBodyMaker.invitation_SendEmail(userId, data, type), null, 'EMAIL 寄送邀請函')
}

// 簡訊 寄送邀請函
export const invitation_SendMSG = async(userId, data) => {
    // if(AJADev) {
    //   return mock.invitation_SendMSG
    // }
    return await axiosWrap('Post', `/RestApiAdapter/INVITATION_SENDMSG_API/invitation_SendMSG`, reqBodyMaker.invitation_SendMSG(userId, data), null, '簡訊 寄送邀請函')
}

// 下載服務件調撥操作手冊(經理版  課長/組訓/區處主管版)
export const downloadFile_b1 = async(userId, ser_no, filename) => {
    // if(AJADev) {
    //   return mock.downloadFile_b1
    // }
    return await axiosWrap('Post', `/RestApiAdapter/DOWNLOAD_FILE_API3/downloadFile_b1`, reqBodyMaker.downloadFile_b1(userId, ser_no, filename), 'blob', '下載服務件調撥操作手冊')
}

//刪除條件篩選的查詢紀錄 (刪單筆,需傳進原record, 刪全部,不用傳record)
export const deleteSearchFilterRecord = async(userId, record = null) => {
    return await axiosWrap('Post', `/RestApiAdapter/DELETE_SEARCH_RECORD_API/delete`, reqBodyMaker.deleteSearchFilterRecord(userId, record), null, '刪除條件篩選的查詢紀錄')
}

// 查詢排訪Log
export const queryVisitEventLog = async(userId) => {
    // if(AJADev) {
    //   return mock.queryVisitEventLog
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/process`, reqBodyMaker.queryVisitEventLog(userId), null, '查詢排訪Log')
}

// 查詢排訪
export const queryVisitEvent = async(userId, serNo, year) => {
    // if(AJADev) {
    //   return mock.queryVisitEvent
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/process`, reqBodyMaker.queryVisitEvent(userId, serNo, year), null, '查詢排訪')
}

// 查詢已安排排訪
export const queryBookedVisitEvent = async(userId, CsidData) => {
    // if(AJADev) {
    //   return mock.queryBookedVisitEvent
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/process`, reqBodyMaker.queryBookedVisitEvent(userId, CsidData), null, '查詢已安排排訪')
}

// 列印申請書
export const getFamilyPrint = async(custData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/showPDF`, reqBodyMaker.getFamilyPrint(custData), null, '列印申請書')
}

// 列印KYC聲明書
export const getKYCPrint = async(userId,currentDate,kyc_lvl_name,custId,print_type) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0002/printKYC_PDF`, reqBodyMaker.getKYCPrint(userId,currentDate,kyc_lvl_name,custId,print_type), null, '列印KYC聲明書')
}

// 下載國壽保險業履行個人資料保護法告知義務內容
export const downloadPersonalInformationProtection = async(userId, filename) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0030/download`, reqBodyMaker.downloadPersonalInformationProtection(userId, filename), null, '下載國壽保險業履行個人資料保護法告知義務內容')
}

// 下載國泰人壽回饋分享金試算表
export const downloadValueAddedBonusIllustration = async(userId, dataJsonStr) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1530/downloadValueAddedBonusIllustration`, reqBodyMaker.downloadValueAddedBonusIllustration(userId, dataJsonStr), null, '下載國泰人壽回饋分享金試算表')
}

// 新增排訪
export const insertVisitEvent = async(userId, reportData) => {
    // if(AJADev) {
    //   return mock.insertVisitEvent
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/process`, reqBodyMaker.insertVisitEvent(userId, reportData), null, '新增排訪')
}

// 編輯排訪
export const updateVisitEvent = async(userId, reportData) => {
    // if(AJADev) {
    //   return mock.updateVisitEvent
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/process`, reqBodyMaker.updateVisitEvent(userId, reportData), null, '編輯排訪')
}

// 刪除排訪
export const deleteVisitEvent = async(userId, reportData) => {
    // if(AJADev) {
    //   return mock.deleteVisitEvent
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_6010/process`, reqBodyMaker.deleteVisitEvent(userId, reportData), null, '刪除排訪')
}

// 名單專區寫入log
export const setListAreaLog = async(userId, ser_no, action_item, cust_id) => {
    // if(AJADev) {
    //   return mock.setListAreaLog
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_0003/process`, reqBodyMaker.setListAreaLog(userId, ser_no, action_item, cust_id), null, '名單專區寫入log')
}

// 查詢名單專區公版名單清單
export const getCustomerSurveyData = async(userId, ser_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_0004/query`, reqBodyMaker.getCustomerSurveyData(userId, ser_no), null, '查詢名單專區公版名單清單')
}

// 建議書客戶寫入生日與性別
export const recommandInserSexAndBir = async(userId, custList) => {
    // if(AJADev) {
    //   return mock.recommandInserSexAndBir
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0020/process`, reqBodyMaker.recommandInserSexAndBir(userId, custList), null, '建議書客戶寫入生日與性別')
}

// 計算保險年齡
export const computeAge = async(userId, birthday) => {
    // if(AJADev) {
    //   return mock.computeAge
    // }
    return await axiosWrap('Post', `/RestApiAdapter/GET_INSURANCE_AGE_API/query`, reqBodyMaker.computeAge(userId, birthday), null, '計算保險年齡')
}

// 查詢業務員與客戶關係
export const queryRelationship = async(userId, agId, custId, api_id) => {
    // if(AJADev) {
    //   return mock.computeAge
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0001/query`, reqBodyMaker.queryRelationship(userId, agId, custId, api_id), null, '查詢業務員與客戶關係')
}

// 查詢業務員與客戶關係_以保單號碼查詢
export const queryRelationshipByPolicyNo = async(userId, policyNo) => {
    // if(AJADev) {
    //   return mock.computeAge
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0002/query`, reqBodyMaker.queryRelationshipByPolicyNo(userId, policyNo), null, '查詢業務員與客戶關係_以保單號碼查詢')
}

// 查詢服務件調撥原因
export const queryTransferReasonByConditions = async(userId, conditions) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0003/query`, reqBodyMaker.queryTransferReasonByConditions(userId, conditions), null, '查詢服務件調撥原因')
}

//新增國泰產險被保人姓名難字設定檔
export const insertDiffWord = async(userId, insertData, policyList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0004/insertDiffWord`, reqBodyMaker.insertDiffWord(userId, insertData, policyList), null, '新增國泰產險被保人姓名難字設定檔')
}

//更新國泰產險被保人姓名難字設定檔
export const updateDiffWord = async(userId, updateData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0004/updateDiffWord`, reqBodyMaker.updateDiffWord(userId, updateData), null, '更新國泰產險被保人姓名難字設定檔')
}

//刪除國泰產險被保人姓名難字設定檔
export const deleteDiffWord = async(userId, deleteData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0004/deleteDiffWord`, reqBodyMaker.deleteDiffWord(userId, deleteData), null, '刪除國泰產險被保人姓名難字設定檔')
}

//更新單筆國泰產險被保人姓名難字設定檔
export const updateSingleDiffWord = async(userId, updateSingleData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0004/updateSingleDiffWord`, reqBodyMaker.updateSingleDiffWord(userId, updateSingleData), null, '更新單筆國泰產險被保人姓名難字設定檔')
}

// 查詢國泰產險被保人姓名難字設定檔
export const queryDiffWord = async(userId, selectData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXQA_0004/queryDiffWord`, reqBodyMaker.queryDiffWord(userId, selectData), null, '查詢國泰產險被保人姓名難字設定檔')
}

// 整合行銷-車/火險預約單
export const getCarFireInsuranceReserve = async(userId, agId) => {
    // if(AJADev) {
    //   return mock.getCarFireInsuranceReserve
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1003/query`, reqBodyMaker.getCarFireInsuranceReserve(userId, agId), null, '整合行銷-車/火險預約單')
}

// 整合行銷-車險預約單
export const getCarInsuranceReserve = async(userId, agId, custId, caseno, seqno) => {
    // if(AJADev) {
    //   return mock.getCarInsuranceReserve
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1004/query`, reqBodyMaker.getCarInsuranceReserve(userId, agId, custId, caseno, seqno), null, '整合行銷-車險預約單')
}

// 整合行銷-火險預約單
export const getFireInsuranceReserve = async(userId, agId, custId, caseno) => {
    // if(AJADev) {
    //   return mock.getFireInsuranceReserve
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1005/query`, reqBodyMaker.getFireInsuranceReserve(userId, agId, custId, caseno), null, '整合行銷-火險預約單')
}

// 整合行銷-車險未續保名單
export const getCarInsuranceUnRenewed = async(userId, agId) => {
    // if(AJADev) {
    //   return mock.getCarInsuranceUnRenewed
    // }
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_3601/query`, reqBodyMaker.getCarInsuranceUnRenewed(userId, agId), null, '整合行銷-車險未續保名單')
}

// 重新歸戶家戶之成員
export const reclassifyFamilyMembers = async(userId, reclassifyData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC2_0002/F03`, reqBodyMaker.reclassifyFamilyMembers(userId, reclassifyData), null, '新增家戶之成員')
}

// 下載異動後實質接觸追蹤表
export const downloadChangeTrace = async(userId, api_id, is_vip, start_date, end_date, group) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_5000/download`, reqBodyMaker.downloadChangeTrace(userId, api_id, is_vip, start_date, end_date, group), 'blob', '下載異動後實質接觸追蹤表')
}

// 下載異動後實質接觸追蹤表KEEP
export const downloadChangeTraceKeep = async(userId, api_id, is_vip, start_date, end_date, group) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_5002/download`, reqBodyMaker.downloadChangeTrace(userId, api_id, is_vip, start_date, end_date, group), 'blob', '下載異動後實質接觸追蹤表KEEP')
}


// 下載強制調撥總表
export const dowlnloadMandatoryAllocationSummary = async(userId, api_id, no_estrange, intime, report) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_4000/download`, reqBodyMaker.dowlnloadMandatoryAllocationSummary(userId, api_id, no_estrange, intime, report), 'blob', '下載強制調撥總表')
}

// 是否至國泰學習網完成調訓課程
export const checkFinishClass = async(userId, classId, userCategoryId) => {
    if (AJADev) {
        return mock.checkFinishClass
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1001/checkFinishClass`, reqBodyMaker.checkFinishClass(userId, classId, userCategoryId), null, '是否至國泰學習網完成調訓課程')
}

// 取得退休人員
export const queryCeclcList = async(userId, divNo) => {
    if (AJADev) {
        return mock.queryCeclcList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1002/queryCeclcList`, reqBodyMaker.queryCeclcList(userId, divNo), null, '取得退休人員')
}

// 更新退休人員
export const updateCeclcList = async(userId, is_back, selectedList) => {
    if (AJADev) {
        return mock.updateCeclcList
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1002/updateCeclcList`, reqBodyMaker.updateCeclcList(userId, is_back, selectedList), null, '更新退休人員')
}

// 取得單位地址座標
export const queryDivLatLnt = async(userId, divNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1007/queryDivLatLnt`, reqBodyMaker.queryDivLatLnt(userId, divNo), null, '取得單位地址座標')
}

// 取得首頁宣傳圖檔資訊
export const queryIndexPopUp = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_7001/query`, reqBodyMaker.queryIndexPopUp(userId), null, '取得首頁宣傳圖檔資訊')
}

// 寫入首頁宣傳圖檔使用者確認
export const insertPopUp = async(userId, type) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_7001/insert`, reqBodyMaker.insertPopUp(userId, type), null, '寫入首頁宣傳圖檔使用者確認')
}

// 活動推廣-企業客戶申辦官網會員名單
export const getCustomerApplyForMember = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1006/query`, reqBodyMaker.getCustomerApplyForMember(userId), null, '活動推廣-企業客戶申辦官網會員名單')
}

// 數位獎勵推動
export const getIonlyU = async(userId, asc) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1010/query`, reqBodyMaker.getIonlyU(userId, asc), null, '數位獎勵推動-iOnly優')
}

// 數位獎勵推動(byCsid)
export const getIonlyU_csid = async(userId, custids) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1010/query`, reqBodyMaker.getIonlyU_csid(userId, custids), null, '數位獎勵推動-iOnly優(byCsid)')
}

// 查詢今天已發送名單
export const getSended = async(userId, custids, type) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_10101/query`, reqBodyMaker.getSended(userId, custids, type), null, '查詢今天已發送名單')
}

// 試打API
export const getIonlyU_API = async(userId, asc) => {
    return await axiosWrap('Post', `/RestApiAdapter/QUERY_LIST1010_API/getAgInfo`, reqBodyMaker.getIonlyU_API(userId, asc), null, '數位獎勵推動-iOnly優(試打API)')
}

// 查詢心安逸將滿期名單
export const getMindWithJoy = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2222/query`, reqBodyMaker.getMindWithJoy(userId), null, '查詢心安逸將滿期名單')
}

// 查詢高階白領企業福利家
export const getHighClassWhiteCollar = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2223/query`, reqBodyMaker.getHighClassWhiteCollar(userId), null, '查詢高階白領企業福利家')
}

// 查詢相同標籤的客戶
export const getSameTagCust = async(userId, tagId, csId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0010/query`, reqBodyMaker.getSameTagCust(userId, tagId, csId), null, '查詢相同標籤的客戶')
}

// 查詢所有客戶標籤
export const getAllCustTag = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0010/queryAllCustTag`, reqBodyMaker.getAllCustTag(userId), null, '查詢所有客戶標籤')
}

// 新增客戶標籤點擊留存log紀錄
export const addCustTagLog = async(userId, logData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC1_0010/addCustTagLog`, reqBodyMaker.addCustTagLog(userId, logData), null, '新增客戶標籤點擊留存log紀錄')
}

// 查詢未申辦 「FitBack健康吧」
export const getCWPList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2225/query`, reqBodyMaker.getCWPList(userId), null, '查詢未申辦 「FitBack健康吧」')
}

// 查詢所有商品類別
export const getAllProdType = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/QUERY_ALLPRODTYPE_API/query`, reqBodyMaker.getAllProdType(userId), null, '查詢所有商品類別')
}

// 修改私人筆記
export const updatePersonalNote = async(userId, csId, note_date, note_time, note_string) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_1020/updatePersonalNote`, reqBodyMaker.updatePersonalNote(userId, csId, note_date, note_time, note_string), null, '修改私人筆記')
}

//取得該業務員底下已加入10個群組的客戶
export const getCustBy10Groups = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/C02`, reqBodyMaker.queryGroup(userId, null, null, userId, null, 'C02', 0), null, '取得該業務員底下已加入10個群組的客戶')
}

// 查詢傷害險調整提高保額
export const getInjuryList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2224/query`, reqBodyMaker.getInjuryList(userId), null, '查詢傷害險調整提高保額')
}

// 查詢網路服務推動名單
export const getWebServicePushList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2226/query`, reqBodyMaker.getWebServicePushList(userId), null, '查詢網路服務推動名單')
}

// 查詢真心守護名單
export const getSincereGuard = async(userId, asc) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2228/query`, reqBodyMaker.getSincereGuard(userId, asc), null, '查詢真心守護名單')
}

// 後台管理_名單管理
export const callCategoryProcess = async(userId, api_id, categoryData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_1000/process`, reqBodyMaker.callCategoryProcess(userId, api_id, categoryData), null, '後台管理_名單管理')
}

// 後台管理_名單管理_附件上傳
export const callFileUpload = async(userId, api_id, file, ser_no) => {
    return await axiosFormData('Post', `/RestApiAdapter/MXZF_0001/uploadFile`, reqBodyMaker.callFileUpload(userId, api_id, file, ser_no), null, '後台管理_附件上傳')
}

// 後台管理_名單管理_附件刪除
export const callFileDelete = async(userId, api_id, ser_no, filename) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXZF_0001/deleteFile`, reqBodyMaker.callFileDelete(userId, api_id, ser_no, filename), null, '後台管理_附件刪除')
}

// 後台管理_佈告欄管理
export const callBullentinProcess = async(userId, bullentinData, api_id, file) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_2000/process`, reqBodyMaker.callBullentinProcess(userId, bullentinData, api_id, file), null, '後台管理_佈告欄管理')
}

// 後台管理_彈跳式廣告新增
export const addPopupData = async(userId, popupData, file) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_7002/create`, reqBodyMaker.addPopupData(userId, popupData, file), null, '後台管理_彈跳式廣告新增')
}

// 後台管理_彈跳式廣告修改
export const updatePopupData = async(userId, popupData, file) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_7002/update`, reqBodyMaker.updatePopupData(userId, popupData, file), null, '後台管理_彈跳式廣告修改')
}

// 後台管理_彈跳式廣告取消申請
export const deletePopupData = async(userId, popupData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_7002/delete`, reqBodyMaker.deletePopupData(userId, popupData), null, '後台管理_彈跳式廣告取消申請')
}

// 後台管理_彈跳式廣告管理查詢
export const callPopupProcess = async(userId, popupData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_3000/process`, reqBodyMaker.callPopupProcess(userId, popupData), null, '後台管理_彈跳式廣告管理查詢')
}

//近期動態按鈕內容
export const getRecentCustButtonContent = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_6001/queryRecentCustButtonContent`, reqBodyMaker.getRecentDynamic(userId), null, '近期動態按鈕內容')
}

// 查詢團險Keyman
export const getGroupInsuranceKeyMan = async(userId, order) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2230/query`, reqBodyMaker.getGroupInsuranceKeyMan(userId, order), null, '查詢團險Keyman')
}

// 首頁_新增近期動態點擊log
export const addIndexDynamicLog = async(userId, logData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_6001/addIndexDynamicLog`, reqBodyMaker.addIndexDynamicLog(userId, logData), null, '首頁_新增近期動態點擊log')
}

// 查詢醫療有約
export const getMedicalEDM = async(userId, order) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2231/query`, reqBodyMaker.getMedicalEDM(userId, order), null, '查詢醫療有約')
}

// 轄下準未訪件接觸追蹤表
// lev1:全部, (yearq, monq)
// lev2:區部, (yearq, monq, cedvno)
// lev3:通訊處, (yearq, monq, cedvno)
// lev44:展業課, (yearq, monq, cedvno)
// lev51:專招推展處, (yearq, monq, cedvno)
// lev54:展業區, (yearq, monq, cedvno)
// lev6:人員, (yearq, monq, cedvno)
export const queryTheRemoteDocumentTracking = async(userId, level, startDate, endDate, cedvno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6005/query`, reqBodyMaker.queryStatsBZEST(userId, level, startDate, endDate, cedvno), null, '轄下準未訪件接觸追蹤表')
}

export const downloadTheRemoteDocumentTracking = async(userId, level, startDate, endDate, cedvno) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_6005/download`, reqBodyMaker.downloadStatsBZEST(userId, level, startDate, endDate, cedvno), 'blob', '轄下準未訪件接觸追蹤表')
}

// 後台管理_客戶ID異動資料查詢
export const queryCustomerIdData = async(userId, queryMap, order) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_4000/process`, reqBodyMaker.queryCustomerIdData(userId, queryMap, order), null, '後台管理_客戶ID異動資料查詢')
}

// 後台管理_客戶ID異動資料新增
export const addCustomerIdData = async(userId, insertMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_4000/process`, reqBodyMaker.addCustomerIdData(userId, insertMap), null, '後台管理_客戶ID異動資料新增')
}

// 後台管理_電話編輯檢視
export const queryEditRecord = async(queryMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_7000/process`, reqBodyMaker.queryEditRecord(queryMap), null, '後台管理_電話編輯檢視');
}

// 後台管理_電話異動查詢
export const queryCustTel = async(queryMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_7000/process`, reqBodyMaker.queryCustTel(queryMap), null, '後台管理_電話異動查詢');
}

// 後台管理_電話異動
export const updateCustTel = async(queryMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_7000/process`, reqBodyMaker.updateCustTel(queryMap), null, '後台管理_電話異動');
}

// 後台管理_客戶資料檢視權限查詢
export const queryCustDataViewPermission = async(userId, queryMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_6000/process`, reqBodyMaker.queryCustDataViewPermission(userId, queryMap), null, '後台管理_客戶資料檢視權限查詢')
}

// 後台管理_客戶資料檢視權限新增
export const addCustDataViewPermission = async(userId, insertMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_6000/process`, reqBodyMaker.addCustDataViewPermission(userId, insertMap), null, '後台管理_客戶資料檢視權限新增')
}

// 後台管理_客戶資料檢視權限解除
export const delCustDataViewPermission = async(userId, deleteMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_6000/process`, reqBodyMaker.delCustDataViewPermission(userId, deleteMap), null, '後台管理_客戶資料檢視權限解除')
}

// 取得客戶標籤名稱
export const queryTagName = async(userId, tag_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_5000/process`, reqBodyMaker.queryTagName(userId, tag_id), null, '取得客戶標籤名稱')
}

// 更新客戶標籤定義和排序
export const updateDefAndSort = async(userId, defMap, sortMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_5000/process`, reqBodyMaker.updateDefAndSort(userId, defMap, sortMap), null, '更新客戶標籤定義和排序')
}

// 異動客戶標籤資料
export const editCustTag = async(userId, tag_id, tagData, api_id, picfile, file1, file2, file3) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_5000/edit`, reqBodyMaker.editCustTag(userId, tag_id, tagData, api_id, picfile, file1, file2, file3), null, api_id == '1' ? '更新客戶標籤資料' : '新增客戶標籤資料')
}

// 下載客戶標籤參考資料
export const downloadTagFile = async(userId, tag_id, filename) => {
    return await axiosWrap('Post', `/RestApiAdapter/PROCESS_CUST_TAG_API/download`, reqBodyMaker.downloadTagFile(userId, tag_id, filename), 'blob', '下載客戶標籤參考資料')
}

// 查詢所有客戶標籤和定義
export const queryAllTagAndDef = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB7_5000/process`, reqBodyMaker.queryAllTagAndDef(userId), null, '查詢所有客戶標籤和定義')
}

// 查詢身故關懷名單
export const getDieCareList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2232/query`, reqBodyMaker.getDataByAgid(userId), null, '查詢身故關懷名單')
}

// 身故關懷名單_保戶身故狀況回報
export const doDieCheck = async(userId, csid, birthday, visit_reply, visit_way, type) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2232/dieCheck`, reqBodyMaker.doDieCheck(userId, csid, birthday, visit_reply, visit_way, type), null, '身故關懷名單_保戶身故狀況回報')
}

// 身故關懷名單_未辦理原因回報
export const doReplyCauseCheck = async(userId, csid, birthday, clcno, reply_cause, reply_memo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2232/replyCauseCheck`, reqBodyMaker.doReplyCauseCheck(userId, csid, birthday, clcno, reply_cause, reply_memo), null, '身故關懷名單_未辦理原因回報')
}

// 合併拜訪記錄
export const mergeVisit = async(userId, csid, csid_new, csname) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC3_1020/mergeVisit`, reqBodyMaker.mergeVisit(userId, csid, csid_new, csname), null, '合併拜訪記錄')
}

//取得未加入任何群組的客戶
export const getCustWithoutGroup = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXG0_0000/C17`, reqBodyMaker.getDataByAgid(userId), null, '取得未加入任何群組的客戶')
}

// 查詢未滿15足歲保障缺口名單
export const getUnder15List = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2233/query`, reqBodyMaker.getDataByAgid(userId), null, '查詢未滿15足歲保障缺口名單')
}

// 未滿15足歲保障缺口名單_回報
export const doInformReply = async(userId, ser_no, inform_result, inform_remark) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2233/informReply`, reqBodyMaker.doInformReply(userId, ser_no, inform_result, inform_remark), null, '未滿15足歲保障缺口名單_回報')
}

// 查詢已歸戶客戶&預設生日排序
export const getCustHasFamily = async(userId, birthdayType) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_0001/queryFamily`, reqBodyMaker.getDataByCurrentAgid(birthdayType), null, '查詢已歸戶客戶&預設生日排序')
}

// 新增預設生日排序
export const insertBirthSort = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_0001/insertBirthSort`, reqBodyMaker.getDataByCurrentAgid(), null, '新增預設生日排序')
}

// 刪除預設生日排序
export const deleteBirthSort = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXCL_0001/deleteBirthSort`, reqBodyMaker.getDataByCurrentAgid(), null, '刪除預設生日排序')
}

// 提醒事項_外溢保單資訊查詢
export const getSpilloverInfo = async(userId, list) => {
    return await axiosWrap('Post', `/RestApiAdapter/QUERY_ATTENTION_API/getSpilloverInfo`, reqBodyMaker.getSpilloverInfo(userId, list), null, '提醒事項_外溢保單資訊查詢')
}

// 查詢外溢證明文件未上傳名單
export const getSpilloverPolicyList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2234/query`, reqBodyMaker.getDataByAgid(userId), null, '查詢外溢證明文件未上傳名單')
}

// 查詢寄送資格/訊息發送狀態
export const getSendResult = async(userId, csid, api_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/SEND_MSG_API/query`, reqBodyMaker.getSendResult(userId, csid, api_id), null, '查詢寄送資格/訊息發送狀態')
}

// 發送簡訊(手機)
export const doSendMsg = async(userId, data) => {
    return await axiosWrap('Post', `/RestApiAdapter/SEND_MSG_API/sendMsg`, reqBodyMaker.doSendAPI(userId, data), null, '發送簡訊(手機)')
}

// 發送Email
export const doSendMail = async(userId, data) => {
    return await axiosWrap('Post', `/RestApiAdapter/SEND_MSG_API/sendMail`, reqBodyMaker.doSendAPI(userId, data), null, '發送Email')
}

// 查詢60周年全面拜訪名單
export const get60AnniversaryList = async(userId, serNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/query60AnniversaryList`, reqBodyMaker.getHighPotentialNewCustomer(userId, serNo), null, '查詢60周年全面拜訪名單')
}

// 60周年全面拜訪名單_無法拜訪客戶回報
export const doReply60AnniversaryList = async(userId, dataMap) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/reply`, reqBodyMaker.doReply60AnniversaryList(userId, dataMap), null, '60周年全面拜訪名單_無法拜訪客戶回報')
}

// 60周年全面拜訪名單_依客戶姓名排序(筆劃)
export const doSort60AnniversaryList = async(userId, order, list) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/sortByName`, reqBodyMaker.doSort60AnniversaryList(userId, order, list), null, '60周年全面拜訪名單_依客戶姓名排序(筆劃)')
}

// 客戶保單_依被保人姓名排序(筆畫)
export const doSortFullnameList = async(userId, order, col, list) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/sortByFullname`, reqBodyMaker.doSortFullnameList(userId, order, col, list), null, '客戶保單_依被保人姓名排序(筆畫)')
}

// 取得分享活動連結文字
export const getShareLinkText = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2235/queryShareLinkText`, reqBodyMaker.getShareLinkText(userId), null, '取得分享活動連結文字')
}


// 查詢外溢保單(保單資訊頁面)
export const getSpilloverPolicyData = async(userId, policy_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1510/query`, reqBodyMaker.getSpilloverPolicyData(userId, policy_no), null, '查詢外溢保單(保單資訊頁面)')
}

// 保代用查詢外溢保單(保單資訊頁面)
export const getSpilloverPolicyForBnk = async(userId, policy_no) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getSpilloverPolicyForBnk`, reqBodyMaker.getSpilloverPolicyForBnk(userId, policy_no), null, '保代用查詢外溢保單(保單資訊頁面)', 'mymv', 'MV')
}

// 取消失聯
export const cancelMissingLost = async(userId, visit_no_list) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2001/query`, reqBodyMaker.cancelMissingLost(userId, visit_no_list), null, '取消失聯')
}

// 查詢信用卡身分驗證異常名單
export const getCreditCardValidationList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2236/query`, reqBodyMaker.getDataByAgid(userId), null, '查詢信用卡身分驗證異常名單')
}

// 依傳入欄位排序(筆劃)
export const doSortList = async(userId, order, list, col) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_1001/sortByName`, reqBodyMaker.doSortList(order, list, col), null, '依傳入欄位排序(筆劃)')
}

// 查詢房貸精準行銷名單
export const getHomeLoanList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_4101/query`, reqBodyMaker.getDataByAgid(userId), null, '查詢房貸精準行銷名單')
}

// 查詢事件偵測_人資神助攻名單
export const queryEventDetectionHR = async(userId, serNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_2240/query`, reqBodyMaker.queryEventDetectionHR(userId, serNo), null, '查詢事件偵測_人資神助攻名單')
}

// 查詢FitBack愛好者名單
export const getFitbackLoverList = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_4102/query`, reqBodyMaker.getFitbackLoverList(userId), null, '查詢FitBack愛好者名單')
}

// 查詢收費轉型關懷名單
export const getPremiumTransformation = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_5101/query`, reqBodyMaker.getDataByAgid(userId), null, '查詢收費轉型關懷名單')
}

// 收費轉型關懷名單_回報排訪結果
export const doVisitReply = async(userId, policy_no, chk_status, pay_way_code) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXM0_5101/reply`, reqBodyMaker.doVisitReply(userId, policy_no, chk_status, pay_way_code), null, '收費轉型關懷名單_回報排訪結果')
}

// 取得泰好客未拜訪問卷網址
export const getSurveyUrl = async(userId, csid, ser_no, subsystem) => {
    return await axiosWrap('Post', `/RestApiAdapter/GET_SURVEY_URL_API/query`, reqBodyMaker.getSurveyUrl(userId, csid, ser_no, subsystem), null, '取得泰好客未拜訪問卷網址')
}

// 更新問卷紀錄
export const updateSurveyRecord = async(userId, quest_no, spot_ser_no) => {
    return await axiosWrap('Post', `/RestApiAdapter/UPDATE_SURVEY_RECORD_API/update`, reqBodyMaker.updateSurveyRecord(userId, quest_no, spot_ser_no), null, '更新問卷紀錄')
}

//-------------------------------------------------------------保單健檢-------------------------------------------------------------
//用業務員ID搜尋戶長
export const getAllHouseholderBySales = async(userId, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/getAllHouseholderBySales`, reqBodyMaker.getAllHouseholderBySales(userId, isFromBank), null, '用業務員ID搜尋戶長', 'mymv', 'MV')
}

//姓名、身分證、保單號碼搜尋家戶
export const getFamilyMemberBycondition = async(userId, conditions) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/getFamilyMemberBycondition`, reqBodyMaker.getFamilyMemberBycondition(userId, conditions), null, '姓名、身分證、保單號碼搜尋家戶', 'mymv', 'MV')
}

//保代用姓名、身分證、保單號碼搜尋家戶
export const getFamilyMemberByConditionBnk = async(userId, conditions) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/getFamilyMemberByConditionBnk`, reqBodyMaker.getFamilyMemberByConditionBnk(userId, conditions), null, '保代用姓名、身分證、保單號碼搜尋家戶', 'mymv', 'MV')
}

//業務員ID&&戶長ID取得家庭成員資料
export const getAllFamily = async(userId, csidno, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/getAllFamily`, reqBodyMaker.getAllFamily(userId, csidno, isFromBank), null, '業務員ID&&戶長ID取得家庭成員資料', 'mymv', 'MV')
}

//PDF(藏寶圖 、 321+1)
export const getPDFFile = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MV_H00100/print`, reqBodyMaker.getPDFFile(userId, sendData), null, 'PDF(藏寶圖 、 321+1)', 'mymv', 'MV')
}

//PDF(藏寶圖 、 321+1)ForMail
export const getPDFFileForMail = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MV_H00100/print`, reqBodyMaker.getPDFFile(userId, sendData), null, 'PDF(藏寶圖 、 321+1)', 'mymv', 'MV')
}

//PDF(家庭保單健檢規劃書)
export const getFamilyCheckPDFFile = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0200/print`, reqBodyMaker.getFamilyCheckPDFFile(userId, sendData), null, 'PDF(家庭保單健檢規劃書)', 'mymv', 'MV')
}

//PDF(家庭保單健檢規劃書)ForMail
export const getFamilyCheckPDFFileForMail = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0200/print`, reqBodyMaker.getFamilyCheckPDFFile(userId, sendData), null, 'PDF(家庭保單健檢規劃書)', 'mymv', 'MV')
}


//取得客服中心報表列印資料
export const getServiceCenterData = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0200/getServiceCenterData`, reqBodyMaker.getServiceCenterData(userId, sendData), null, '取得客服中心報表列印資料', 'mymv', 'MV')
}

//PDF(家庭保單健檢規劃書)(取得檔案)
export const getFamilyCheckPDFFileByFileNo = async(userId, fileNo) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download`, reqBodyMaker.getFamilyCheckPDFFileByFileNo(userId, fileNo), 'arraybuffer', 'PDF(家庭保單健檢規劃書)(取得檔案)', 'mymv', 'MV')
}


//查詢常用報表
export const getCommonlyUsedReport = async(userId, report) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVG0_0100/getCommonlyUsedReport`, reqBodyMaker.getCommonlyUsedReport(userId, report), null, '查詢常用報表', 'mymv', 'MV')
}

//新增常用報表
export const insertCommonlyUsedReport = async(userId, report, reportType) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVG0_0100/insertCommonlyUsedReport`, reqBodyMaker.insertCommonlyUsedReport(userId, report, reportType), null, '查詢常用報表', 'mymv', 'MV')
}


//刪除常用報表
export const deleteCommonlyUsedReport = async(userId, report, reportType) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVG0_0100/deleteCommonlyUsedReport`, reqBodyMaker.deleteCommonlyUsedReport(userId, report, reportType), null, '查詢常用報表', 'mymv', 'MV')
}


//取得保單資訊
export const getContractContent = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getContractContent`, reqBodyMaker.getContractContent(userId, sendData), null, '取得保單資訊', 'mymv', 'MV')
}

//修改家戶資料
export const modifyFamilyMember = async(userId, sendData, checkDeleteCount, checkOnlyId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0102/modifyFamilyMember`, reqBodyMaker.modifyFamilyMember(userId, sendData, checkDeleteCount, checkOnlyId), null, '修改家戶資料', 'mymv', 'MV')
}

//修改家戶資料(保代)
export const modifyFamilyMember_BNK = async(userId, sendData,checkRemoveCount, checkDeleteCount, checkOnlyId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0102/modifyFamilyMember_BNK`, reqBodyMaker.modifyFamilyMember_BNK(userId, sendData,checkRemoveCount, checkDeleteCount, checkOnlyId), null, '修改家戶資料', 'mymv', 'MV')
}
//確認家戶成員是否有保單
export const checkPolicyExist = async(userId, sendData, familyId, isFromBank) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/checkPolicyExist`, reqBodyMaker.checkPolicyExist(userId, sendData, familyId, isFromBank), null, '確認家戶成員是否有保單', 'mymv', 'MV')
}

//確認家戶成員是否有保單
export const isCustomerAgreeRemind = async(userId, familyId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/isCustomerAgreeRemind`, reqBodyMaker.isCustomerAgreeRemind(userId, familyId), null, '確認業務員是否以點選過家戶關係', 'mymv', 'MV')
}


//刪除家戶
export const deleteFamily = async(userId, sendData, isFromBank) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0102/deleteFamily`, reqBodyMaker.deleteFamily(userId, sendData, isFromBank), null, '刪除家戶', 'mymv', 'MV')
}

//取得國壽壽險保單資訊
export const getCathayInsurance = async(userId, sendData , isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getCathayInsurance`, reqBodyMaker.getCathayInsurance(userId, sendData , isFromBank), null, '取得國壽壽險保單資訊', 'mymv', 'MV')
}

//取得同業、建議書保單資訊
export const getOtherInsurance = async(userId, sendData, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getOtherInsurance`, reqBodyMaker.getOtherInsurance(userId, sendData , isFromBank), null, '取得同業、建議書保單資訊', 'mymv', 'MV')
}

//取得國壽壽險保單資訊（要保人視角）
export const getCathayInsuranceApplicant = async(userId, sendData) => {
  return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getCathayInsurance`, reqBodyMaker.getCathayInsuranceApplicant(userId, sendData), null, '取得國壽壽險保單資訊(要保人)', 'mymv', 'MV')
}

//取得同業、建議書保單資訊（要保人視角）
export const getOtherInsuranceApplicant = async(userId, sendData) => {
  return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getOtherInsurance`, reqBodyMaker.getOtherInsuranceApplicant(userId, sendData), null, '取得同業、建議書保單資訊(要保人)', 'mymv', 'MV')
}

//取得同業、建議書保單資訊ForMX
export const getOtherInsuranceForMX = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getOtherInsurance`, reqBodyMaker.getOtherInsuranceForMX(userId, sendData), null, '取得同業、建議書保單資訊', 'mymv', 'MV')
}

//取得團險保單資訊
export const getGroupInsurance = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getGroupInsurance`, reqBodyMaker.getGroupInsurance(userId, sendData), null, '取得團險保單資訊', 'mymv', 'MV')
}

//取得國壽產險保單資訊
export const getCathayPropertyInsurance = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getCathayPropertyInsurance`, reqBodyMaker.getCathayPropertyInsurance(userId, sendData), null, '取得國壽產險保單資訊', 'mymv', 'MV')
}

//取得同業產險保單資訊
export const getOtherPropertyInsurance = async(userId, sendData, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0100/getOtherPropertyInsurance`, reqBodyMaker.getOtherPropertyInsurance(userId, sendData , isFromBank), null, '取得同業產險保單資訊', 'mymv', 'MV')
}

//取得產險保單資訊
export const getPropertyInsurance = async(userId, sendData, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0300/getPropertyInsurance`, reqBodyMaker.getPropertyInsurance(userId, sendData , isFromBank), null, '取得產險保單資訊', 'mymv', 'MV')
}

//取得產險保單資訊
export const ckeckPropertyInsuranceCustomers = async(userId, sendData, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0300/ckeckPropertyInsuranceCustomers`, reqBodyMaker.ckeckPropertyInsuranceCustomers(userId, sendData , isFromBank), null, '檢查產險客戶', 'mymv', 'MV')
}

//查詢國泰產險-健康險
export const getCustInsurance_CCIPLN4MV = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayHealth
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0005/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true), null, '國泰產險-健康險')
}

//查詢國泰產險-傷害險
export const getCustInsurance_CCIPLN2MV = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayHarm
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0006/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true), null, '國泰產險-傷害險')
}

//查詢國泰產險-新種險
export const getCustInsurance_CCIPLN1MV = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayNewInsure
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0007/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true), null, '國泰產險-新種險')
}

//查詢國泰產險-車險
export const getCustInsurance_CCIPLC1MV = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayCar
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0010/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true), null, '國泰產險-車險')
}

//查詢國泰產險-火險
export const getCustInsurance_CCIPLF1MV = async(userId, csid) => {
    if (AJADev) {
        return mock.cathayFire
    }
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_0011/query`, reqBodyMaker.queryCustPropertyInsurance(userId, csid, true), null, '國泰產險-火險')
}

//以單一家庭成員ID查詢戶長
export const getFamilyMemberByCsidNo = async(userId, sendData, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/getFamilyMemberByCsidNo`, reqBodyMaker.getFamilyMemberByCsidNo(userId, sendData, isFromBank), null, '以單一家庭成員ID查詢戶長', 'mymv', 'MV')
}

//將選中家戶成員加入現有家戶
export const addMembersToFamily = async(userId, newFamilyId, addFamilyMembers, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0104/addMembersToFamily`, reqBodyMaker.addMembersToFamily(userId, newFamilyId, addFamilyMembers, isFromBank), null, '將選中家戶成員加入現有家戶', 'mymv', 'MV')
}

//更換原家戶戶長
export const changeFamilyLeader = async(userId, LastFamilyResult, newFamilyId, addFamilyMembers, isFromBank=false) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0104/changeFamilyLeader`, reqBodyMaker.changeFamilyLeader(userId, LastFamilyResult, newFamilyId, addFamilyMembers, isFromBank), null, '更換原家戶戶長', 'mymv', 'MV')
}

//成立新的家戶
export const createNewFamily = async(userId, newFamilyId, addFamilyMembers) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0104/createNewFamily`, reqBodyMaker.createNewFamily(userId, newFamilyId, addFamilyMembers), null, '更換原家戶戶長', 'mymv', 'MV')
}

//新增同仁眷屬檔
export const addAGFamily = async(userId, insertData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0105/addAGFamily`, reqBodyMaker.addAGFamily(userId, insertData), null, '新增同仁眷屬檔', 'mymv', 'MV')
}

//刪除同仁眷屬檔
export const deleteAGFamily = async(userId, deleteData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0105/deleteAGFamily`, reqBodyMaker.deleteAGFamily(userId, deleteData), null, '刪除同仁眷屬檔', 'mymv', 'MV')
}

//搜尋是否有此業務員
export const checkAGExist = async(userId, selectData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0105/checkAGExist`, reqBodyMaker.checkAGExist(userId, selectData), null, '搜尋是否有此業務員', 'mymv', 'MV')
}

//查詢業務員資料
export const selectAGData = async(userId, selectData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0105/selectAGData`, reqBodyMaker.selectAGData(userId, selectData), null, '查詢業務員資料', 'mymv', 'MV')
}

//查詢業務員資料
export const selectAGDeleteData = async(userId, selectDeleteData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0105/selectAGDeleteData`, reqBodyMaker.selectAGDeleteData(userId, selectDeleteData), null, '查詢業務員資料', 'mymv', 'MV')
}


//取得報表列印PDF說明
export const getPdfFileForReport = async(userId, filename) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/downloadFile_m0`, reqBodyMaker.getPdfFileForReport(userId, filename), 'arraybuffer', '取得報表列印PDF說明', 'mymv', 'MV')
}

//取得當年度保障
export const getCurrentYearCoverageDetail = async(userId, familyid, cslistAll, type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0200/getCurrentYearCoverageDetail`, reqBodyMaker.getCurrentYearCoverageDetail(userId, familyid, cslistAll, type), null, '取得當年度保障', 'mymv', 'MV')
}

//取得基本醫療保障
export const getMedicalCoverageDetail = async(userId, familyid, cslistAll, type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0200/getMedicalCoverageDetail`, reqBodyMaker.getMedicalCoverageDetail(userId, familyid, cslistAll, type), null, '取得當年度保障', 'mymv', 'MV')
}

//查詢逐月保費
export const getPremiumTotalListDataSetDetail = async(userId, familyid, cslistAll, checkApc) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0300/getPremiumTotalListDataSetDetail`, reqBodyMaker.getPremiumTotalListDataSetDetail(userId, familyid, cslistAll, checkApc), null, '查詢逐月保費', 'mymv', 'MV')
}

//保障查詢-逐年保費一覽表(保障總覽)API
export const getEachYearPremiunSummary = async(userId, familyId, CSLIST, checkApc) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0400/getEachYearPremiunSummary`, reqBodyMaker.getEachYearPremiunSummary(userId, familyId, CSLIST, checkApc), null, '逐年保費一覽表(保障總覽)API', 'mymv', 'MV');
}

//保障查詢-逐年保費一覽表(個人資料)API
export const getEachYearPremiunDetail = async(userId, familyId, CSLIST, checkApc) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0400/getEachYearPremiunDetail`, reqBodyMaker.getEachYearPremiunDetail(userId, familyId, CSLIST, checkApc), null, '逐年保費一覽表(個人資料)API', 'mymv', 'MV');
}

//保障查詢-滿期金或年金領回(家戶總覽)API
export const getAnnuityCoverageSummary = async(userId, familyId, CSLIST) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0500/getAnnuityCoverageSummary`, reqBodyMaker.getAnnuityCoverageSummary(userId, familyId, CSLIST), null, '滿期金或年金領回(家戶總覽)API', 'mymv', 'MV');
}

//保障查詢-滿期金或年金領回(個人資料)API
export const getAnnuityCoverageDetail = async(userId, familyId, CSLIST) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0500/getAnnuityCoverageDetail`, reqBodyMaker.getAnnuityCoverageDetail(userId, familyId, CSLIST), null, '滿期金或年金領回(個人資料)API', 'mymv', 'MV');
}

//保障查詢-身故/失能逐年保障查詢(家戶總覽)API
export const getDeathCoverageSummary = async(userId, familyId, CSLIST) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0600/getDeathCoverageSummary`, reqBodyMaker.getDeathCoverageSummary(userId, familyId, CSLIST), null, '身故/失能逐年保障查詢(家戶總覽)API', 'mymv', 'MV');
}

//保障查詢-身故/失能逐年保障查詢(個人資料)API
export const getDeathCoverageDetail = async(userId, familyId, CSLIST) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0600/getDeathCoverageDetail`, reqBodyMaker.getDeathCoverageDetail(userId, familyId, CSLIST), null, '身故/失能逐年保障查詢(個人資料)API', 'mymv', 'MV');
}

//-------------------------------------------------------------保單健檢-------------------------------------------------------------

export const getCity = () => {
    return [
        { city: '台北市' },
        { city: '基隆市' },
        { city: '新北市' },
        { city: '宜蘭縣' },
        { city: '新竹市' },
        { city: '新竹縣' },
        { city: '桃園市' },
        { city: '苗栗縣' },
        { city: '台中市' },
        { city: '彰化縣' },
        { city: '南投縣' },
        { city: '嘉義市' },
        { city: '嘉義縣' },
        { city: '雲林縣' },
        { city: '台南市' },
        { city: '高雄市' },
        { city: '屏東縣' },
        { city: '台東縣' },
        { city: '花蓮縣' },
        { city: '金門縣' },
        { city: '連江縣' },
        { city: '澎湖縣' },
        { city: '南海島' }
    ]
}

//取得客戶列表
export const queryRelationList = async(userId, input, s1, s2, s3, s4, s5, s6, order_by, order_asc) => {
    return await axiosWrap('post', `/servlet/HttpDispatcher/MVA0_0101/query`, reqBodyMaker.queryRelationList(userId, input, s1, s2, s3, s4, s5, s6, order_by, order_asc), null, '客戶基本資料', 'mymv', 'MV')
}

//取得相關保單資訊
export const queryPolicyList = async(userId, cust_id, order_by, order_asc) => {
    return await axiosWrap('post', `/servlet/HttpDispatcher/MVA0_0101/queryPolicy`, reqBodyMaker.queryPolicyList(userId, cust_id, order_by, order_asc), null, '相關保單資料', 'mymv', 'MV')
}

//查詢保單關係人資訊
export const queryPolicyRelateList = async(userId, data, order_by, order_asc) => {
    return await axiosWrap('post', `/servlet/HttpDispatcher/MVA0_0101/queryPolicyRelateList`, reqBodyMaker.queryPolicyRelateList(userId, data, order_by, order_asc), null, '查詢保單關係人資訊', 'mymv', 'MV')
}

// 新增保代客戶到家戶
export const insertCustInFamilyBnk = async(userId, insertData, idList) => {
    return await axiosWrap('post', `/servlet/HttpDispatcher/MVA0_0103/insert_BNK`, reqBodyMaker.insertCustInFamilyBnk(userId, insertData, idList), null, '新增保代客戶到家戶', 'mymv', 'MV')
}

// 新增客戶到家戶
export const insertCustInFamily = async(userId, insertData, idList, hasSpouse, trn_cd) => {
    return await axiosWrap('post', `/servlet/HttpDispatcher/MVA0_0103/insert`, reqBodyMaker.insertCustInFamily(userId, insertData, idList, hasSpouse, trn_cd), null, '新增客戶到家戶', 'mymv', 'MV')
}

export const updateCustInFamily = async(userId, insertData) => {
    return await axiosWrap('post', `/servlet/HttpDispatcher/MVA0_0102/insert`, reqBodyMaker.updateCustInFamily(userId, insertData), null, '新增客戶到家戶', 'mymv', 'MV')
}

//取得業務員列印用聯絡資訊
export const getAgntInfo = async(userId, agnt_id) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0100/query`, reqBodyMaker.getAgntInfo(userId, agnt_id), null, '取得業務員列印用聯絡資訊', 'mymv', 'MV')
}

//修改業務員列印用聯絡資訊
export const updateAgntInfo = async(userId, updateData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0100/update`, reqBodyMaker.updateAgntInfo(userId, updateData), null, '修改業務員列印用聯絡資訊', 'mymv', 'MV')
}

// //新增國泰產險被保人姓名難字設定檔
// export const insertDiffWord = async(userId, insertData, policyList) => {
//     return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0200/insertDiffWord`, reqBodyMaker.insertDiffWord(userId, insertData, policyList), null, '新增國泰產險被保人姓名難字設定檔', 'mymv', 'MV')
// }

// //更新國泰產險被保人姓名難字設定檔
// export const updateDiffWord = async(userId, updateData) => {
//     return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0200/updateDiffWord`, reqBodyMaker.updateDiffWord(userId, updateData), null, '更新國泰產險被保人姓名難字設定檔', 'mymv', 'MV')
// }

// //刪除國泰產險被保人姓名難字設定檔
// export const deleteDiffWord = async(userId, deleteData) => {
//     return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0200/deleteDiffWord`, reqBodyMaker.deleteDiffWord(userId, deleteData), null, '刪除國泰產險被保人姓名難字設定檔', 'mymv', 'MV')
// }

// //更新單筆國泰產險被保人姓名難字設定檔
// export const updateSingleDiffWord = async(userId, updateSingleData) => {
//     return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0200/updateSingleDiffWord`, reqBodyMaker.updateSingleDiffWord(userId, updateSingleData), null, '更新單筆國泰產險被保人姓名難字設定檔', 'mymv', 'MV')
// }

// //查詢國泰產險被保人姓名難字設定檔
// export const queryDiffWord = async(userId, selectData) => {
//     return await axiosWrap('Post', `/servlet/HttpDispatcher/MVD0_0200/queryDiffWord`, reqBodyMaker.queryDiffWord(userId, selectData), null, '更新單筆國泰產險被保人姓名難字設定檔', 'mymv', 'MV')
// }

//取得產險公司下拉清單
export const getInsuranceCompanies = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0101/getInsuranceCompanies`, reqBodyMaker.getInsuranceCompanies(userId), null, '取得產險公司下拉清單', 'mymv', 'MV')
}

//取得合併後產險公司下拉清單
export const getMrgerInsuranceCompanies = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0101/getMrgerInsuranceCompanies`, reqBodyMaker.getMergeInsuranceCompanies(userId), null, '取得合併後產險公司下拉清單', 'mymv', 'MV')
}

//新增火，車，新種險
export const createOtherPropertyInsurance = async(body) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0104/insert`, reqBodyMaker.createRequestBody(body), null, 'create產險', 'mymv', 'MV')
    }
    //查詢火，車，新種險
export const queryOtherPropertyInsurance = async(body) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0104/query`, reqBodyMaker.createRequestBody(body), null, 'query產險', 'mymv', 'MV')
    }
    //update火，車，新種險
export const updateOtherPropertyInsurance = async(body) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0104/update`, reqBodyMaker.createRequestBody(body), null, 'update產險', 'mymv', 'MV')
    }
    //delete火，車，新種險
export const deleteOtherPropertyInsurance = async(body) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0104/delete`, reqBodyMaker.createRequestBody(body), null, 'delete產險', 'mymv', 'MV')
}

//新增自行輸入國泰產險保單
export const insertSelfInputPropertyNumber = async(userId, insurances) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0105/insertSelfInputPropertyNumber`, reqBodyMaker.insertSelfInputPropertyNumber(userId, insurances), null, '新增自行輸入國泰產險保單', 'mymv', 'MV')
    }
    //查詢是否有自行輸入國泰產險保單
export const getQuerySelfInputPropertyNumber = async(userId, insuredID, policyNumber) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0105/getQuerySelfInputPropertyNumber`, reqBodyMaker.getQuerySelfInputPropertyNumber(userId, insuredID, policyNumber), null, '查詢是否有自行輸入國泰產險保單', 'mymv', 'MV')
    }
    //查詢拒絕產險共同行銷紀錄
export const getRejectPropertyComarketing = async(userId, insuredID) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0105/getRejectPropertyComarketing`, reqBodyMaker.getRejectPropertyComarketing(userId, insuredID), null, "查詢是否同意產險共同行銷", "mymv", "MV");
};

//查詢自行輸入國泰產險保單
export const getExistsSelfInputProperty = async(userId, agent, nums) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0105/getExists`, reqBodyMaker.getExistsSelfInputProperty(userId, agent, nums), null, "查詢自行輸入國泰產險保單", "mymv", "MV");
};

//查詢保單與客戶關係
export const getPolicyConsumerRelationship = async(userId, insuredID, policyNumber) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0105/getPolicyConsumerRelationship`, reqBodyMaker.getPolicyConsumerRelationship(userId, insuredID, policyNumber), null, "查詢保單與客戶關係", "mymv", "MV");
};

//取得公司別下拉清單
export const getCompanies = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0101/getCompanies`, reqBodyMaker.getCompanies(userId), null, '取得公司別下拉清單', 'mymv', 'MV')
}

//取得險種下拉清單
export const getInsuranceTypes = async(userId, companyid, contracttype) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0101/getInsuranceTypes`, reqBodyMaker.getInsuranceTypes(userId, companyid, contracttype), null, "取得險種下拉清單", "mymv", "MV");
};

//新增自行輸入國泰壽險保單號碼
export const insertSelfInputPolicyNumber = async(userId, insurances) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0103/insertSelfInputPolicyNumber`, reqBodyMaker.insertSelfInputPolicyNumber(userId, insurances), null, '新增自行輸入國泰壽險保單號碼', 'mymv', 'MV')
}

//取得年期
export const getAnnual = async(userId, productid) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0101/getAnnual`, reqBodyMaker.getAnnual(userId, productid), null, "取得年期下拉清單", "mymv", "MV");
};

//取得計畫別
export const getPlan = async(userId, productid) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0101/getPlan`, reqBodyMaker.getPlan(userId, productid), null, "取得計畫別下拉清單", "mymv", "MV");
};

//是否可以檢視自行輸入國壽保單
export const canViewCreateInsuranceMyself = async(userId, agent_id, id) => {
    return await axiosWrap("Post", `/servlet/HttpDispatcher/MVC0_0101/canViewCreateInsuranceMyself`, reqBodyMaker.canViewCreateInsuranceMyself(userId, agent_id, id), null, "是否可以檢視自行輸入國壽保單", "mymv", "MV");
};

// 用policy查主次被保人
export const getRelationsByPolicyID = async(body) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0101/getRelationsByPolicyID`, reqBodyMaker.createRequestBody(body), null, ' 用policy查主次被保人', 'mymv', 'MV')
}

//create其他同業壽險
export const createOtherLifeInsurance = async(body) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0102/insert`, reqBodyMaker.createRequestBody(body), null, 'create其他國壽壽險', 'mymv', 'MV')
    }
    //update其他同業壽險
export const updateOtherLifeInsurance = async(body) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0102/update`, reqBodyMaker.createRequestBody(body), null, 'update其他國壽壽險', 'mymv', 'MV')
    }
    //query其他同業壽險
export const queryOtherLifeInsurance = async(body) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0102/query`, reqBodyMaker.createRequestBody(body), null, 'query其他國壽壽險', 'mymv', 'MV')
    }
    //delete其他同業壽險
export const deleteOtherLifeInsurance = async(body) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0102/delete`, reqBodyMaker.createRequestBody(body), null, 'delete其他國壽壽險', 'mymv', 'MV')
}

//保障查詢-查詢細項
export const getCoverageDetail = async(userId, policyNumber, isPolicyId, cslistAll, isSelfInsert, checkApc) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0700/getCoverageDetail`, reqBodyMaker.getCoverageDetail(userId, policyNumber, isPolicyId, cslistAll, isSelfInsert, checkApc), null, '保障查詢細項', 'mymv', 'MV');
    }
    //保障查詢-當年度保障查詢(保障總覽)API
export const getCurrentYearCoverageSummary = async(userId, familyId, CSLIST, type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0100/getCurrentYearCoverageSummary`, reqBodyMaker.getCurrentYearCoverageSummary(userId, familyId, CSLIST, type), null, '當年度保障查詢(保障總覽)API', 'mymv', 'MV');
}

//保障查詢-未來保障視圖API
export const getAllCoverageForView = async(userId, familyId, CSLIST, typeList,filterList) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_0800/getAllCoverageForView`, reqBodyMaker.getAllCoverageForView(userId, familyId, CSLIST, typeList,filterList), null, '未來保障視圖API', 'mymv', 'MV');
}

//保障查詢-取得保障項目API
export const getCurrentYearCoverageItem = async(type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVF0_Z001/getCurrentYearCoverageItem`, reqBodyMaker.createRequestBody({type:type}), null, '取得保障項目API', 'mymv', 'MV');
}

//查詢是否為家庭型保單
export const getQueryPlcnoIdnoFamily = async(userId, idno, plcno) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0103/getQueryPlcnoIdnoFamily`, reqBodyMaker.getQueryPlcnoIdnoFamily(userId, idno, plcno), null, '查詢是否為家庭型保單', 'mymv', 'MV');
}

//新增家庭型保單眷屬資料
export const addContractFamilyRelationList = async(userId, familyRelationList, originalFamilyList) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC4_1520/query`, reqBodyMaker.addContractFamilyRelationList(userId, familyRelationList, originalFamilyList), null, '新增家庭型保單眷屬資料');
}

//新增家庭型保單眷屬資料
export const addContractFamilyRelationListMV = async(userId, familyRelationList, originalFamilyList) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0103/query`, reqBodyMaker.addContractFamilyRelationList(userId, familyRelationList, originalFamilyList), null, '新增家庭型保單眷屬資料', 'mymv', 'MV');
}

//查詢自行輸入國壽保單檢核訊息
export const getSelfCheckMsg = async(userId, plcnoList,isFromBank) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0103/getSelfCheckMsg`, reqBodyMaker.getSelfCheckMsg(userId, plcnoList,isFromBank), null, '查詢自行輸入國泰壽險保單檢核訊息', 'mymv', 'MV');
}

//查詢生日不同之被保人資訊
export const checkBirthDayDifferent = async(userId, CSLIST , isFromBank) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/checkBirthDayDifferent`, reqBodyMaker.checkBirthDayDifferent(userId, CSLIST, isFromBank), null, '查詢生日不同之被保人資訊', 'mymv', 'MV');
}

//檢核經管人才能自行輸入國壽保代
export const checkBnkCustomerAssign = async(userId, policyNoList) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/checkBnkCustomerAssign`, reqBodyMaker.checkBnkCustomerAssign(userId, policyNoList), null, '檢核經管人才能自行輸入國壽保代', 'mymv', 'MV');
}

//檢核客戶名單是否有未授權之公司同事
export const checkCompanyColleague = async(userId, CSLIST) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/checkCompanyColleague`, reqBodyMaker.checkCompanyColleague(userId, CSLIST), null, '檢核客戶名單是否有未授權之公司同事', 'mymv', 'MV');
}

//寫入生日不一致保單log紀錄
export const differBirthDayLog = async(userId, diffData, source = "") => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/differBirthDayLog`, reqBodyMaker.differBirthDayLog(userId, diffData, source), null, '寫入生日不一致保單log紀錄', 'mymv', 'MV');
}

//刪除自行輸入國泰產險保單
export const deleteSelfInputPropertyNumber = async(userId, plcno, pln) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0105/deleteSelfInputPropertyNumber`, reqBodyMaker.deleteSelfInputPropertyNumber(userId, plcno, pln), null, '刪除自行輸入國泰產險保單', 'mymv', 'MV');
}

//刪除自行輸入國泰壽險保單
export const deleteSelfInputPolicyNumber = async(userId, plcno ,isFromBank) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0103/deleteSelfInputPolicyNumber`, reqBodyMaker.deleteSelfInputPolicyNumber(userId, plcno ,isFromBank), null, '刪除自行輸入國泰壽險保單', 'mymv', 'MV');
}

//新/舊保健切換API
export const dotNetJavaConcat = async(userId, concatCode) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVA0_0100/dotNetJavaConcat`, reqBodyMaker.dotNetJavaConcat(userId, concatCode), null, '新/舊保健切換API', 'mymv', 'MV');
}

//取得指定刪除客戶
export const queryDeleteConsumer = async(userId, id, serNo) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXC0_0002/queryDelete`, reqBodyMaker.queryDeleteConsumer(userId, id, serNo), null, '取得指定刪除客戶')
}

//今日刪除客戶名單
export const getTodayDeleteList = async(userId, orderBy, order) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_6001/queryDeleteList`, reqBodyMaker.queryTodayDeleteList(userId, orderBy, order), null, '今日刪除客戶名單')
}

//今日刪除客戶按鈕內容
export const getTodayDeleteButtonContent = async(userId) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXH0_6001/queryDeleteButtonContent`, reqBodyMaker.getRecentDynamic(userId), null, '今日刪除客戶按鈕內容')
}

//取得視訊平台連結
export const getMeetingServiceLink = async() => {
    return await axiosWrap('post', `/RestApiAdapter/MXZA_0001/getMeetingServiceLink`, {}, null, '取得視訊平台連結')
}

// 取得新舊報表比對結果
export const getPDFcomparedResult = async(userId, agidno, csidno) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0300/getPDFcomparedResult`, reqBodyMaker.getPDFcomparedResult(userId, agidno, csidno), null, '取得新舊報表比對結果', 'mymv', 'MV', false)
}

// 刪除新舊報表比對結果
export const deletePDFcomparedResult = async(userId, agidno, csidno) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0300/deletePDFcomparedResult`, reqBodyMaker.deletePDFcomparedResult(userId, agidno, csidno), null, '刪除新舊報表比對結果', 'mymv', 'MV', false)
}

// 後台管理-新增保單遮蔽資料
export const addPolicyCovered = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVZ0_0200/addHidePolicyData`, reqBodyMaker.addPolicyCovered(userId, reqData), null, '新增保單遮蔽資料', 'mymv', 'MV', false)
}

// 後台管理-查詢保單遮蔽資料
export const queryPolicyCovered = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVZ0_0200/queryHidePolicyData`, reqBodyMaker.queryPolicyCovered(userId, reqData), null, '查詢保單遮蔽資料', 'mymv', 'MV', false)
}

// 後台管理-刪除保單遮蔽資料
export const deletePolicyCovered = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVZ0_0200/deleteHidePolicyData`, reqBodyMaker.deletePolicyCovered(userId, reqData), null, '刪除保單遮蔽資料', 'mymv', 'MV', false)
}

// 後台管理-查詢保單遮蔽刪除紀錄資料
export const queryPolicyCoveredDelete = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVZ0_0200/queryHidePolicyDeleteData`, reqBodyMaker.queryPolicyCoveredDelete(userId, reqData), null, '查詢保單遮蔽刪除紀錄資料', 'mymv', 'MV', false)
}

//商品設定-查詢尚未發布商品列表
export const getUnreleasedProduct = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/getUnreleasedProduct`, reqBodyMaker.getUnreleasedProduct(userId), null, '查詢尚未發布商品列表', 'mymv', 'MV');
}

//商品設定-查詢已暫存商品列表
export const querySavedProduct = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/querySavedProduct`, reqBodyMaker.querySavedProduct(userId, reqData), null, '查詢已暫存商品列表', 'mymv', 'MV');
}

//商品設定-查詢已暫存商品明細
export const getSavedProductDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/getSavedProductDetail`, reqBodyMaker.getSavedProductDetail(userId, reqData), null, '查詢已暫存商品明細', 'mymv', 'MV');
}

//商品設定-查詢計畫別資料
export const querySchemeData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/querySchemeData`, reqBodyMaker.querySchemeData(userId, reqData), null, '查詢計畫別資料', 'mymv', 'MV');
}

//商品設定-新增計畫別資料
export const insertSchemeData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/insertSchemeData`, reqBodyMaker.insertSchemeData(userId, reqData), null, '新增計畫別資料', 'mymv', 'MV');
}

//商品設定-編輯計畫別資料
export const updateSchemeData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/updateSchemeData`, reqBodyMaker.updateSchemeData(userId, reqData), null, '編輯計畫別資料', 'mymv', 'MV');
}

//商品設定-刪除計畫別資料
export const deleteSchemeData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/deleteSchemeData`, reqBodyMaker.deleteSchemeData(userId, reqData), null, '刪除計畫別資料', 'mymv', 'MV');
}

//商品設定-新增商品暫存資料
export const tempSaveInsuranceProduct = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/tempSaveInsuranceProduct`, reqBodyMaker.tempSaveInsuranceProduct(userId, reqData), null, '新增商品暫存資料', 'mymv', 'MV');
}

//商品設定-更新商品設定商品暫存資料
export const updateTempSavedInsuranceProduct = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/updateTempSavedInsuranceProduct`, reqBodyMaker.updateTempSavedInsuranceProduct(userId, reqData), null, '更新商品設定商品暫存資料', 'mymv', 'MV');
}

//商品設定-刪除商品設定商品暫存資料
export const deleteTempSavedInsuranceProduct = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/deleteTempSavedInsuranceProduct`, reqBodyMaker.deleteTempSavedInsuranceProduct(userId, reqData), null, '刪除商品設定商品暫存資料', 'mymv', 'MV');
}

//商品設定-複製商品資料
export const copyInsuranceProduct = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/copyInsuranceProduct`, reqBodyMaker.getCoverageSummary(reqData), null, '複製商品資料', 'mymv', 'MV');
}

//商品設定-查詢商品是否可刪除
export const getIsProductDeletable = async(userId, productId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/getIsProductDeletable`, reqBodyMaker.getIsProductDeletable(userId, productId), null, '查詢商品是否可刪除', 'mymv', 'MV');
}

//商品設定-查詢投資型利率變動型保障摘要
export const getInvestFormulaSummary = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/getInvestFormulaSummary`, reqBodyMaker.getInvestFormulaSummary(userId, reqData), null, '查詢投資型利率變動型保障摘要', 'mymv', 'MV');
}

//商品設定-查詢投資型利率變動型保單價值摘要
export const getInvestValueFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/getInvestValueFormula`, reqBodyMaker.getInvestValueFormula(userId, reqData), null, '查詢投資型利率變動型保單價值摘要', 'mymv', 'MV');
}

//商品設定-查詢投資型利率變動型身故及完全失能保障摘要
export const getDeathAndDisabilityFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/getDeathAndDisabilityFormula`, reqBodyMaker.getDeathAndDisabilityFormula(userId, reqData), null, '查詢投資型利率變動型身故及完全失能保障摘要', 'mymv', 'MV');
}

//商品設定-查詢投資型利率變動型生存保險金保障摘要
export const getLivingFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/getLivingFormula`, reqBodyMaker.getLivingFormula(userId, reqData), null, '查詢投資型利率變動型生存保險金保障摘要', 'mymv', 'MV');
}

//商品設定-查詢投資型利率變動型滿期保險金保障摘要
export const getMaturityBenefitFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/getMaturityBenefitFormula`, reqBodyMaker.getMaturityBenefitFormula(userId, reqData), null, '查詢投資型利率變動型滿期保險金保障摘要', 'mymv', 'MV');
}

//商品設定-新增投資型利率變動型保障公式
export const addInvestFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/addInvestFormula`, reqBodyMaker.addInvestFormula(userId, reqData), null, '新增投資型利率變動型保障公式', 'mymv', 'MV');
}

//商品設定-刪除所有投資型利率變動型保障公式
export const deleteAllInvestFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/deleteAllInvestFormula`, reqBodyMaker.deleteAllInvestFormula(userId, reqData), null, '刪除所有投資型利率變動型保障公式', 'mymv', 'MV');
}

//商品設定-刪除投資型利率變動型保障公式
export const deleteInvestFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/deleteInvestFormula`, reqBodyMaker.deleteInvestFormula(userId, reqData), null, '刪除投資型利率變動型保障公式', 'mymv', 'MV');
}

//商品設定-編輯投資型利率變動型保障公式
export const updateInvestFormula = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/updateInvestFormula`, reqBodyMaker.updateInvestFormula(userId, reqData), null, '編輯投資型利率變動型保障公式', 'mymv', 'MV');
}

//商品設定-更新投資型利率變動型保障公式順序
export const updateInvestFormulaPriority = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0120/updateInvestFormulaPriority`, reqBodyMaker.updateInvestFormulaPriority(userId, reqData), null, '更新投資型利率變動型保障公式順序', 'mymv', 'MV');
}

//商品設定-查詢資料庫匯率列表
export const getExchangeRate = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0200/getExchangeRate`, reqBodyMaker.getExchangeRate(userId), null, '查詢資料庫匯率列表', 'mymv', 'MV');
}

//商品設定-以關鍵字查詢商品
export const queryProductByKeyWord = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/queryProductByKeyWord`, reqBodyMaker.queryProductByKeyWord(userId, reqData), null, '以關鍵字查詢商品', 'mymv', 'MV');
}

//商品設定-以單一備註查詢商品清單
export const queryProductListByStateId = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/queryProductListByStateId`, reqBodyMaker.queryProductListByStateId(userId, reqData), null, '以單一備註查詢商品清單', 'mymv', 'MV');
}

//商品設定-新增報表註解
export const insertReportNoteDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/insertReportNoteDetail`, reqBodyMaker.insertReportNoteDetail(userId, reqData), null, '新增報表註解', 'mymv', 'MV');
}

//商品設定-更新報表註解
export const updateReportNoteDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/updateReportNoteDetail`, reqBodyMaker.updateReportNoteDetail(userId, reqData), null, '更新報表註解', 'mymv', 'MV');
}

//商品設定-查詢報表備註內容
export const getReportNoteDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/getReportNoteDetail`, reqBodyMaker.getReportNoteDetail(userId, reqData), null, '查詢報表備註內容', 'mymv', 'MV');
}

//商品設定-停用報表註解
export const disableReportNote = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/disableReportNote`, reqBodyMaker.disableReportNote(userId, reqData), null, '停用報表註解', 'mymv', 'MV');
}

//商品設定-刪除報表註解
export const deleteReportNote = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/deleteReportNote`, reqBodyMaker.deleteReportNote(userId, reqData), null, '刪除報表註解', 'mymv', 'MV');
}

//商品設定-查詢公司資料
export const getCompanyData = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0500/getCompanyData`, reqBodyMaker.getCompanyData(userId), null, '查詢公司資料', 'mymv', 'MV');
}

//商品設定-新增公司資料
export const insertCompanyData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0500/insertCompanyData`, reqBodyMaker.insertCompanyData(userId, reqData), null, '新增公司資料', 'mymv', 'MV');
}

//商品設定-編輯公司資料
export const updateCompanyData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0500/updateCompanyData`, reqBodyMaker.updateCompanyData(userId, reqData), null, '編輯公司資料', 'mymv', 'MV');
}

//商品設定-刪除公司資料
export const deleteCompanyData = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0500/deleteCompanyData`, reqBodyMaker.deleteCompanyData(userId, reqData), null, '刪除公司資料', 'mymv', 'MV');
}

//商品設定-查詢保險給付歸類
export const queryCoverageCategoryMain = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0600/queryCoverageCategoryMain`, reqBodyMaker.queryCoverageCategoryMain(userId), null, '查詢保險給付歸類', 'mymv', 'MV');
}

//商品設定-編輯保險給付歸類
export const updateCoverageCategoryMain = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0600/updateCoverageCategoryMain`, reqBodyMaker.updateCoverageCategoryMain(userId, reqData), null, '編輯保險給付歸類', 'mymv', 'MV');
}

//商品設定-刪除保險給付歸類
export const deleteCoverageCategoryMain = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0600/deleteCoverageCategoryMain`, reqBodyMaker.deleteCoverageCategoryMain(userId, reqData), null, '刪除保險給付歸類', 'mymv', 'MV');
}

//商品設定-新增保險給付歸類
export const newCoverageCategoryMain = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0600/newCoverageCategoryMain`, reqBodyMaker.newCoverageCategoryMain(userId, reqData), null, '新增保險給付歸類', 'mymv', 'MV');
}

//商品設定-查詢所有報表種類
export const getAllReportType = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/getAllReportType`, reqBodyMaker.getAllReportType(userId), null, '查詢所有報表種類', 'mymv', 'MV');
}

//商品設定-查詢備註歷史清單
export const getReportNoteRecord = async(userId, reqData) => {
        return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0400/getReportNoteRecord`, reqBodyMaker.getReportNoteRecord(userId, reqData), null, '查詢備註歷史清單', 'mymv', 'MV');
    }
    //商品設定-查詢保障項目列表
export const queryCoverageCategory = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/queryCoverageCategory`, reqBodyMaker.queryCoverageCategory(userId, reqData), null, '查詢保障項目列表', 'mymv', 'MV');
}

//商品設定-查詢保障項目
export const getCoverageItemDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/getCoverageItemDetail`, reqBodyMaker.getCoverageItemDetail(userId, reqData), null, '查詢保障項目', 'mymv', 'MV');
}

//商品設定-編輯保障項目
export const updateCoverageItemDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/updateCoverageItemDetail`, reqBodyMaker.updateCoverageItemDetail(userId, reqData), null, '編輯保障項目', 'mymv', 'MV');
}

//商品設定-新增保障項目
export const insertCoverageItemDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/insertCoverageItemDetail`, reqBodyMaker.insertCoverageItemDetail(userId, reqData), null, '新增保障項目', 'mymv', 'MV');
}

//商品設定-刪除保障項目
export const deleteCoverageItemDetail = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/deleteCoverageItemDetail`, reqBodyMaker.deleteCoverageItemDetail(userId, reqData), null, '刪除保障項目', 'mymv', 'MV');
}

//商品設定-查詢保障項目對應商品
export const queryCoverage = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/queryCoverage`, reqBodyMaker.queryCoverage(userId, reqData), null, '查詢保障項目對應商品', 'mymv', 'MV');
}

//商品設定-查詢年期資料
export const getYearPeriod = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0800/getYearPeriod`, reqBodyMaker.getYearPeriod(userId), null, '查詢年期資料', 'mymv', 'MV');
}

//商品設定-新增年期資料
export const insertYearPeriod = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0800/insertYearPeriod`, reqBodyMaker.insertYearPeriod(userId, reqData), null, '新增年期資料', 'mymv', 'MV');
}

//設定註解-取得保障分類與項目
export const getCoverageItems = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getCoverageItems`, reqBodyMaker.getCoverageItems(userId), null, '取得保障分類與項目', 'mymv', 'MV');
}

//設定註解-取得保障備註
export const getCoverageNotes = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getCoverageNotes`, reqBodyMaker.getCoverageNotes(userId, reqData), null, '取得保障備註', 'mymv', 'MV');
}

//設定註解-新增保障備註
export const addCoverageNote = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/addCoverageNote`, reqBodyMaker.addCoverageNote(userId, reqData), null, '新增保障備註', 'mymv', 'MV');
}

//設定註解-刪除保障備註
export const deleteCoverageNotes = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteCoverageNotes`, reqBodyMaker.deleteCoverageNotes(userId, reqData), null, '刪除保障備註', 'mymv', 'MV');
}

//設定註解-刪除全部保障備註
export const deleteAllCoverageNote = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteAllCoverageNote`, reqBodyMaker.deleteAllCoverageNote(userId, reqData), null, '刪除全部保障備註', 'mymv', 'MV');
}

//保障摘要-取得保障摘要
export const getCoverageSummary = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getCoverageSummary`, reqBodyMaker.getCoverageSummary(reqData), null, '取得保障摘要', 'mymv', 'MV');
}

//初始化保障資料頁
export const initCoverage = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/initCoverage`, reqBodyMaker.getCoverageSummary(reqData), null, '初始化保障資料頁', 'mymv', 'MV');
}

//保障資料頁-查詢
export const getCoverage = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getCoverage`, reqBodyMaker.getCoverageSummary(reqData), null, '查詢保障資料頁', 'mymv', 'MV');
}

//保障資料頁-查詢編輯資料
export const getCoverageForEdit = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getCoverageForEdit`, reqBodyMaker.getCoverageSummary(reqData), null, '查詢編輯保障資料頁', 'mymv', 'MV');
}

//儲存保障資料
export const saveCoverage = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/saveCoverage`, reqBodyMaker.getCoverageSummary(reqData), null, '儲存保障資料', 'mymv', 'MV');
}

//保障資料頁-刪除
export const deleteCoverage = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteCoverage`, reqBodyMaker.getCoverageSummary(reqData), null, '刪除保障資料', 'mymv', 'MV');
}

//保障資料頁-複製
export const copyCoverage = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/copyCoverage`, reqBodyMaker.getCoverageSummary(reqData), null, '複製保障資料', 'mymv', 'MV');
}

//共用- 交換保障條件順序
export const exchangeConditionPriority = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/exchangeConditionPriority`, reqBodyMaker.getCoverageSummary(reqData), null, '交換保障條件順序', 'mymv', 'MV');
}

//儲存取大設定資料
export const saveGetMax = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/saveGetMax`, reqBodyMaker.getCoverageSummary(reqData), null, '儲存取大設定資料', 'mymv', 'MV');
}

//取大設定資料-查詢編輯資料
export const getMaxForEdit = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getMaxForEdit`, reqBodyMaker.getCoverageSummary(reqData), null, '查詢編輯取大設定資料', 'mymv', 'MV');
}

//取大設定資料-刪除
export const deleteGetMax = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteGetMax`, reqBodyMaker.getCoverageSummary(reqData), null, '刪除取大設定資料', 'mymv', 'MV');
}

//取大設定資料(包含FORM資料)-刪除
export const deleteAllMax = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteAllMax`, reqBodyMaker.getCoverageSummary(reqData), null, '刪除取大設定及FORM資料', 'mymv', 'MV');
}

//FORM8資料-批次新增
export const batchInsertForm8 = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/batchInsertForm8`, reqBodyMaker.getCoverageSummary(reqData), null, '批次新增FORM8資料', 'mymv', 'MV');
}

//FORM8資料-查詢
export const getForm8Data = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getForm8Data`, reqBodyMaker.getCoverageSummary(reqData), null, '查詢FORM8資料', 'mymv', 'MV');
}

//FORM8資料-刪除
export const deleteForm8Data = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteForm8Data`, reqBodyMaker.getCoverageSummary(reqData), null, '刪除FORM8資料', 'mymv', 'MV');
}

//FORM501資料-批次新增
export const batchInsertForm501 = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/batchInsertForm501`, reqBodyMaker.getCoverageSummary(reqData), null, '批次新增FORM501資料', 'mymv', 'MV');
}

//FORM501資料-查詢
export const getForm501Data = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/getForm501Data`, reqBodyMaker.getCoverageSummary(reqData), null, '查詢FORM501資料', 'mymv', 'MV');
}

//FORM501資料-刪除
export const deleteForm501Data = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0110/deleteForm501Data`, reqBodyMaker.getCoverageSummary(reqData), null, '刪除FORM501資料', 'mymv', 'MV');
}

//取得幣別清單
export const getCurrencyList = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0130/getCurrencyList`, reqBodyMaker.getCoverageSummary(reqData), null, '取得幣別清單', 'mymv', 'MV');
}

//取得保障項目清單
export const getCoverageList = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0130/getCoverageList`, reqBodyMaker.getCoverageSummary(reqData), null, '取得保障項目清單', 'mymv', 'MV');
}

//取得取大保障項目清單
export const getMaxCoverageList = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0130/getMaxCoverageList`, reqBodyMaker.getCoverageSummary(reqData), null, '取得取大保障項目清單', 'mymv', 'MV');
}

//取得傳統型取大保障項目清單
export const getTraditionMaxCoverageList = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0130/getTraditionMaxCoverageList`, reqBodyMaker.getCoverageSummary(reqData), null, '取得取大保障項目清單', 'mymv', 'MV');
}

//商品設定-試算公式
export const calculateCoverage = async(reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0100/backendCoverageCalculate`, reqBodyMaker.calculateCoverage(reqData), null, '後台商品試算', 'mymv', 'MV');
}

/**
 * 查詢離退人員(2023/13工後入職者)對應增員者名單
 * @param {String} userId 使用者ID
 * @param {String} cedvno3 單位代號前3碼
 * @returns 
 */
export const getResignIntrList = async(userId, cedvno3) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1009/query`, reqBodyMaker.getResignIntrList(userId, cedvno3), null, '查詢離退人員(2023/13工後入職者)對應增員者名單');
}

/**
 * 新增/更新離退人員(2023/13工後入職者)對應增員者解鎖檔
 * @param {String} userId 使用者ID
 * @param {Object} reqData 解鎖資料
 * @returns 
 */
export const doResignUnlock = async(userId, reqData) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1010/resignUnlock`, reqBodyMaker.doResignUnlock(userId, reqData), null, '新增/更新離退人員(2023/13工後入職者)對應增員者解鎖檔');
}

/**
 * 查詢離退人員對應增員者是否解鎖
 * @param {String} userId 使用者ID
 * @param {String} resign_id 離退人員_id
 * @param {String} intr_id 增員者_id
 * @returns 
 */
export const doQueryResignUnlock = async(userId, resign_id, intr_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1010/queryResignUnlock`, reqBodyMaker.doQueryResignUnlock(userId, resign_id, intr_id), null, '查詢離退人員對應增員者是否解鎖');
}

/**
 * 查詢離退人員主管未覆核資料清單
 * @param {String} userId 使用者ID
 * @param {String} cedvno3 單位代號前3碼 
 * @param {String} type 執行類型
 * @param {String} c_id 確認者ID
 * @returns 
 */
export const doQueryResignList = async(userId, cedvno3, type, c_id) => {
    return await axiosWrap('Post', `/RestApiAdapter/MXB1_1010/queryResignList`, reqBodyMaker.doQueryResignList(userId, cedvno3, type, c_id), null, '查詢離退人員主管未覆核資料清單');
}

//BFF專案是否有登入
export const checkBFFIsLoggedIn = async() => {
    try {
        return await axiosWrap('get', `/api/v1/isLoggedIn`, null, null, 'BFF專案是否有登入');
    } catch (error) {
        console.error('checkBFFIsLoggedIn API 呼叫失敗:', error);
        return false; 
    }
}

//透過參數對照查詢bff登入是否開啟
export const isBffLoginEnabled = async() => {
    let isBffLoginEnabled = false;
    try{
        let response = await axiosWrap('Post', `/api/v1/MFB09100/isBffLoginEnabled`, reqBodyMaker.initMedicalExpenseLimit()/*借用傳入參數*/ , null, '透過參數對照查詢bff登入是否開啟');
        if (
            response &&
            response.body &&
            response.body.crmvue_isBFF === true
        ) {
            isBffLoginEnabled = true;
        }
    }catch (error) {
        console.warn('isBffLoginEnabled API 呼叫失敗:', error);
        isBffLoginEnabled = false; 
    }
    return isBffLoginEnabled;
}